// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./image/purple_banner_cranes.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-thumb {
    background: #888;
}


.grecaptcha-badge {
    visibility: hidden;
}

.price-three-dots-loading {
    justify-content: end;
}

.CookieConsent > div {
    flex: 1 0 !important;
}

.foreman {
    padding-right: 50px !important;
}

.arrow_top_bottom {
    position: fixed;
    z-index: 99;
    cursor: pointer;
    bottom: 100px;
    right: 25px;
    background: #592C82;
    color: #FFF;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25)
}

/* Button Declare */
.primary_button_drillcut {
    background: #FFFFFF !important;
    border-radius: 5px;
    font-weight: 700;
    font-size: 15px !important;
    line-height: 24px !important;
    font-family: acumin-pro, sans-serif !important;
    color: #1A1A1A;
    padding: 5px;
    transition: all .5s ease;
}

.primary_button_drillcut:hover {
    background: #592C82 !important;
    color: #fff;
}

.secondary_button_drillcut {
    font-weight: 700;
    font-size: 15px !important;
    line-height: 24px !important;
    background: #592C82 !important;
    border-radius: 5px;
    font-family: acumin-pro, sans-serif !important;
    color: #FFF;
    padding: 5px;
    transition: all .5s ease;
    border: 1px solid #592C82 !important;
}

.secondary_button_drillcut:hover {
    background-color: #FFF !important;
    color: #1A1A1A;
    border: 1px solid #1A1A1A !important;
}

.orange_button_drillcut {
    background: #EC7700 !important;
    border-radius: 5px !important;
    text-align: center;
    font-weight: 700;
    font-size: 15px !important;
    line-height: 24px !important;
    color: #FFF;
    padding: 5px;
    border: 1px solid #EC7700 !important;
}

.product-input-search {
    background-color: #fff !important;
    border: 1px solid #444 !important;
    border-radius: none !important;
}

.table-small-padding {
    padding-left: 1em !important;
    padding-right: 1em !important;
}

.orange_button_drillcut:hover {
    background-color: #FFF !important;
    color: #1A1A1A;
    border: 1px solid #1A1A1A !important;
}

.transparent_button_drillcut {
    background: transparent;
    border-radius: 5px;
    text-align: center;
    font-weight: 700;
    font-size: 15px;
    line-height: 24px;
    color: #FFF;
    padding: 5px;
}

.transparent_button_drillcut:hover, .transparent_button_drillcut[data-hover] {
    background: #EC7700 !important;
    border-color: transparent !important;
}

.orange_background_drillcut {
    background: #EC7700 !important;
}

.lightgray_background_drillcut {
    background: #F2F2F2;
}

/* Chakra css Update */
.chakra-text {
    width: 100%;
    display: block;
}

.text_align_center {
    text-align: center;
}

.chakra-heading {
    font-family: acumin-pro, sans-serif !important;
}

.text_color_b_shade {
    color: #1A1A1A;
}

.policies-content {
    width: 80%;
    margin: 30px auto;
    text-align: initial;
    max-width: 1450px !important;
}

.policies-content p {
    margin: 15px 0;
}

/* Main container */

.main_container.menuByCollections {
    padding: 0 40px;
    margin: 0 !important;
    max-width: 1600px !important;
}

.overlaybody {
    display: block;
    position: absolute;
    top: 46px;
    overflow: hidden;
    left: 0;
    right: 0;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    z-index: 1;
}

.drill_cut_tv_popup_heading {
    text-align: center;
    letter-spacing: 0.18px;
    font-weight: 700;
    font-size: 24px !important;
    line-height: 24px !IMPORTANT;
    margin-bottom: 10px !important;
}

.drill_cut_tv_popup_content {
    font-size: 20px !IMPORTANT;
    text-align: center;
    margin-bottom: 15px !important;
    letter-spacing: 0.18px;
    line-height: 20px !IMPORTANT;
}

.main_container {
    max-width: 1450px !important;
    margin: auto;
    width: 100%;
    margin: auto;
    position: relative;
}

.mini_1250_container {
    max-width: 1250px !important;
    margin: auto;
}

.mini_1100_container {
    max-width: 1100px !important;
    margin: auto;
}

.half_mini_width_drillcut {
    width: 33.33%;
}

.flipping-book {
    width: 100%;
    margin: 50px auto;
    max-width: 1450px;
    height: 1000px;
}

.box_section_mt {
    width: 100%;
    max-width: 100%;
}

.width_40DrillCut {
    width: 40%;
    max-width: 100%;
}

.width_60DrillCut {
    width: 60%;
    max-width: 100%;
}

.width_50DrillCut {
    width: 50%;
    max-width: 100%;
}

.width_25DrillCut {
    width: 25%;
    max-width: 100%;
}

.width_75DrillCut {
    width: 75%;
    max-width: 100%;
}

/*.box_width_70 {*/
/*    width: 70%;*/
/*    max-width: 100%;*/
/*}*/

.Full_width_blockDrillcut {
    width: 100%;
    max-width: 100%;
}

.drillcut_purple {
    color: #592C82;
}

/* Homeage announcmentbar */
.announment_bar_homepage_mt {
    padding: 13px;
    color: #FFF;
    text-transform: uppercase;
}

/* Home page first section css */
.homepage_announcment_heading_text_mt {
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 17px !important;
    font-family: acumin-pro, sans-serif !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

span.homepage_announcment_heading_logo_mt {
    margin-right: 12px;
}

.main_slider_home_heading_mt {
    font-weight: 400 !important;
    font-size: 24px !important;
    line-height: 29px !important;
    display: flex;
    align-items: center;
    letter-spacing: 0.18px;
    font-family: acumin-pro, sans-serif !important;
}

.slider_image_mt {
    width: 100%;
    background-size: cover;
    /*height: 582px;*/
}

.main_slider_home_button {
    border: 1px solid #FFF;
    background: transparent !important;
    width: 239px !important;
    height: 48px !important;
    font-style: normal;
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 56px !important;
    font-family: acumin-pro, sans-serif !important;
}

.slider_components_mt {
    display: flex !important;
}

.home_page_main_slider_mt {
    position: relative;
}

.home_page_main_slider_mt .slick-dots {
    top: 70%;
    bottom: unset !important;
    min-width: 200px;
    padding-left: 160px;
    text-align: left;
}

.home_page_main_slider_mt .slick-dots li {
    margin: 0 0.25rem;
}

.home_page_main_slider_mt .slick-dots button {
    display: block;
    width: 1rem;
    height: 1rem;
    padding: 0;
    border: none;
    border-radius: 100%;
    background-color: #F2F2F2;
    text-indent: -9999px;
}

.home_page_main_slider_mt li.slick-active button {
    background-color: #EC7700;
}

.home_page_main_slider_mt .slick-arrow {
    display: none !important;
}

.slick_slider_custom_arrows {
    max-width: 537px;
    justify-content: space-around;
    height: 30px;
    position: absolute;
    top: 70%;
    left: 0;
    right: 0;
}

.slick_slider_custom_arrow svg {
    fill: #FFF;
    width: 25px;
    height: 25px;
}

.productpricearticlepage {
    letter-spacing: 0.18px;
    text-decoration-line: underline;
    color: #1A1A1A;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
}

.slick_slider_custom_arrow {
    position: absolute;
    margin-top: 6px;
    z-index: 1;
}

.slick_right_arrow {
    left: 47%;
}

.slick_left_arrow {
    left: 23%;
}

.cart_mobile_view {
    margin-bottom: 15px;
}

/*  Drill cut second section */

.box_design {
    height: 244px;
    margin: 0 8px;
    background-size: cover;
    position: relative;
}

.box_homepage_designs {
    width: 100%;
    height: 100%;
    color: #FFF;
    position: relative;
}

.blog_design_mt img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

#player {
    max-width: 100%;
    width: 100%;
}

.Image_container {
    width: 100%;
    height: 260px;
}

.search_Image_container {
    width: 100%;
    height: 180px;
    position: relative;
}

.box_homepage_designs_content {
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    left: 0;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    bottom: 15%;
}

.box_homepage_designs_image_div {
    position: absolute;
    right: 0;
}

.box_homepage_designs_heading {
    letter-spacing: 0.15px;
    font-size: 35px !important;
    line-height: 24px !important;
    font-family: acumin-pro, sans-serif !important;
    width: 100%;
    text-align: left !important;
    margin-bottom: 8px;
}

.box_homepage_designs_heading_first_w {
    font-weight: 700;
}

.box_homepage_designs_heading_second_w {
    font-weight: 300;
}

.box_homepage_designs_mini_heading {
    letter-spacing: 0.15px;
    font-weight: 500 !important;
    font-size: 20px !important;
    line-height: 24px !important;
    margin-top: 5px;
}

.box_homepage_designs_button_box {
    display: block;
    width: 100%;
}

.box_homepage_designs_button {
    display: block;
    width: 130px;
    margin-top: 25px;
    text-align: center;
}

/* Slider Logo Section */
.mini_container_mt {
    max-width: 1250px !important;
}

.Logo_icons_full_width {
    width: 100%;
    max-width: 100%;
    padding: 20px 0;
}

.logo_icons_logo_mt {
    width: 216px;
    display: grid !important;
    height: 116px;
    justify-content: center;
    align-items: center;
}

.logo_slider_home_mt .slick-arrow {
    width: 54px;
    height: 54px;
    z-index: 99;
}

/* Text with logo section css */
.Background_color_schema_div {
    width: 100%;
    max-width: 100%;
    background: #F2F2F2;
    padding: 55px 25px 55px;
}

.icons_with_text_heading_home_mt {
    max-width: 1000px !important;
    margin: auto;
    margin-bottom: 35px;
}

.logo_text_block_contain {
    justify-content: center;
}

.logo_text_block_contain_heading {
    color: #1A1A1A;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: left;
    width: 155px;
}

.text_main_home_mt {
    max-width: 1100px !important;
    margin: auto;
}

.text_main_home_mt_contain {
    letter-spacing: 0.5px;
    color: #000000;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 45px;
}

.text_main_home_mt_button_mt {
    width: 250px;
    display: block;
    margin: auto;
}

/* Banner Image Section */
.background_image_banner_image {
    height: 400px;
    background-repeat: no-repeat;
    background-size: cover;
}

.background_image_mt {
    position: relative;
}

.background_image_mt_container {
    max-width: 1200px !important;
    margin: auto;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
}

.background_image_mt_content_main {
    height: 100%;
    color: #FFF;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-left: 120px;
}

.background_image_mt_content_main_heading {
    letter-spacing: -0.5px;
    font-weight: 700 !important;
    font-size: 54px !important;
    line-height: 54px !important;
    font-family: acumin-pro, sans-serif !important;
    margin-bottom: 10px;
}

span.background_image_mt_content_mini_heading {
    font-weight: 300 !important;
}

.background_image_mt_content_main_text {
    letter-spacing: 0.15px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: left;
    margin-bottom: 20px;
    max-width: 390px;
}

.banner_button_mt {
    width: 114px;
}

/* Latest Product css */
.latest_product_heading {
    color: #4D4D4D;
    letter-spacing: 0.18px;
    font-weight: 700 !important;
    font-size: 24px !important;
    line-height: 24px !important;
    margin-bottom: 35px;
    font-family: acumin-pro, sans-serif !important;
}


.backgorund_latest_prod_mt {
    background-color: #F4F4F4;
}

.latest_product_div_mt {
    height: 260px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
    margin: 0 12px;
}

.backgorund_latest_prod_image {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.box_view_design_mt {
    justify-content: center;
}


.latest_product_contain {
    margin-bottom: 20px;
    justify-content: center;
}

.latest_product_div_contain {
    padding: 25px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

p.latest_product_div_contain_icon {
    margin-bottom: 10px;
}

p.chakra-text.latest_product_div_contain_heading {
    color: #1A1A1A;
    letter-spacing: 0.18px;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 5px;
}

.latest_product_div_contain_button {
    width: 155px;
    display: block;
    margin-top: 25px;
}

p.latest_product_div_contain_price {
    color: rgba(26, 26, 26, 0.5);
    letter-spacing: 0.18px;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
}

/* Blog section css */
.blog_design_mt {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    background: #FFF;
}

.blog_contain_mt {
    padding: 30px 25px !important;
    text-align: left;
    min-height: 110px;
}

.blog_heading_mt {
    color: #592C82;
    font-size: 20px !important;
    line-height: 22px !important;
    letter-spacing: 0.1px;
    text-transform: capitalize;
    display: block;
    font-weight: 600;
}

.blog_mini_heading_mt {
    color: #592C82;
    font-size: 16px !important;
    line-height: 24px !important;
    margin-top: 3px;
    font-weight: 600;
}

.blog_content_mt {
    font-size: 14px !important;
    line-height: 20px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
}

.blog_design_mt {
    margin: 0 8px 20px;
}

.blog_search_page_image {
    height: 180px;
}

.imageblogssearchpage {
    width: 100%;
    max-width: 100%;
    object-fit: cover;
    height: 100%;
}

.blog_design_mt img {
    width: 100%;
}

.blog_contain_searchpage {
    padding: 20px !important;
    text-align: left;
}

.blog_section_drillcut {
    margin-bottom: 20px;
}

.blog_section_home_button_div {
    margin-top: 15px;
    margin-bottom: 15px;
}

.blog_section_home_button {
    width: 250px;
    display: block;
    text-align: center;
    margin: auto;
}

.blog_design_mt_image {
    position: relative;
    width: 100%;
}

.drillcut_tv_play_icon {
    position: absolute !important;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100% !important;
    height: 100% !important;
    background: transparent !important;
}

.drillcut_tv_play_icon svg {
    fill: #FFF;
}

.drillcut_tv_play_icon svg {
    fill: #FFF;
    width: 65px;
    height: 65px;
}

.slick_arrows_custom_logo {
    position: absolute;
    top: 35%;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
    width: 54px;
    height: 54px;
    border-radius: 100%;
    z-index: 99;
    background: #FFF;
}

.slick_arrows_custom_logo_next {
    right: 18px;
}

.slick_arrows_custom_logo_previous {
    left: 18px;
}

.slick_arrows_custom_logo svg {
    width: 20px;
    margin: auto;
    height: 20px;
}

/* Model css */
.drill_cut_tv_popup {
    max-width: 70% !important;
    background: #F2F2F2 !important;
    border-radius: 0 !important;
    position: relative;
}

.drill_cut_tv_popup_hover {
    background: rgba(0, 0, 0, 0.5) !important;
}

.drill_cut_tv_popup_body {
    padding: 15px 0 0 0 !important;
}

.drillcuttv_popup_close_btn {
    position: absolute !important;
    right: -15px !important;
    top: -15px !important;
    width: 45px !important;
    background: rgba(242, 242, 242, 1);
    border-radius: 100% !important;
    height: 45px !important;
}

.drillcuttv_popup_close_btn:hover, .drillcuttv_popup_close_btn[data-hover] {
    background: rgba(242, 242, 242, 1) !important;
}

.drillcuttv_popup_close_btn:focus, .drillcuttv_popup_close_btn[data-focus] {
    box-shadow: none !important;
}

.menu_drawer_overlay {
    transform: translateX(0) translateY(70px) translateZ(0px) !important;
}

.menu_drawer_overlay {
    transform: translateX(0) translateY(70px) translateZ(0px) !important;
    background: rgba(0, 0, 0, 0.5) !important;
}

.chiled_header {
    justify-content: center;
}

.drawermenu_item_mt span {
    height: 17px;
}

.instagram_section_images img {
    width: 100%;
}

.drillcutreusultcount {
    padding: 50px 0;
    letter-spacing: -0.5px;
    font-weight: 700;
    font-size: 54px;
    line-height: 54px;
    color: #FFF;
    text-align: left;
}

/* ========================================== About Us page Drillcut ============================================ */

.pages_AnnouncmentBar {
    background: #592C82;
    width: 100%;
    text-align: left;
    color: #FFF;
}

.about_announcment_container {
    padding: 70px 15px;
    max-width: 1450px;
    margin: auto;
}

.pages_announment_bar_sub_heading {
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
}

.pages_announment_bar_heading {
    letter-spacing: -0.5px;
    font-weight: 700 !important;
    font-size: 54px !important;
    line-height: 54px !important;
    color: #FFF;
}

.slider_box {
    color: #FFF;
}

.about_us_content_mt {
    max-width: 860px;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: left;
}

.video_about_mt {
    max-width: 650px;
    margin: auto;
    margin-bottom: 60px;
    position: relative;
}

.about_us_page_video_mt {
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 0;*/
    /*left: 0;*/
    /*bottom: 0;*/
    justify-content: center;
    align-items: center;
    background: rgba(242, 242, 242, 0.5);
}

.about_us_page_video_button {
    background: transparent !important;
}

.about_us_page_video_button svg {
    width: 50px;
    height: 50px;
    fill: #FFF;
}

.about_us_brands_heading {
    font-size: 24px !important;
    line-height: 24px !important;
    color: #1A1A1A;
    letter-spacing: 0.18px;
    margin-bottom: 10px;
}

.about_us_page_video_button:hover, .about_us_page_video_button[data-hover] {
    background: transparent !important;
}

.about_us_page_video_button:focus, .about_us_page_video_button[data-focus] {
    box-shadow: none !important;
}

.heading_image_withtext_about {
    font-size: 24px !important;
    letter-spacing: 0.18px;
    color: #000;
    line-height: 24px !important;
    font-weight: 700 !important;
    margin-bottom: 15px;
}

.content_image_withtext_about {
    letter-spacing: 0.5px;
    font-weight: 300 !important;
    font-size: 16px;
    line-height: 24px;
}

.button_mt_about {
    margin: 25px 0 !important;
}

.about_main {
    padding: 100px 0 60px !important;
}

.about_slider_bg_image_mt {
    background-size: cover;
    min-height: 600px;
    background-position: center center;
    position: relative;
}

.about_page_slider_container_mt {
    max-width: 1200px !important;
    margin: auto;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.about_page_slider_container_contentmt {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    position: relative;
}

.about_page_slider_container_mt_heading {
    letter-spacing: 0.18px;
    font-weight: 700;
    font-size: 24px !important;
    line-height: 24px !important;
    color: rgba(255, 255, 255, 0.5);
}

.about_us_page_slider {
    width: 700px !important;
}

.about_us_page_sliderContent {
    font-weight: 700;
    font-size: 34px;
    line-height: 36px;
}

.about_us_page_sliderheading {
    font-weight: 400;
    font-size: 18px;
    line-height: 38px;
    margin-top: 15px;
    margin-bottom: 25px;
}

.aboutuspage_sliderButton {
    padding: 6px 25px !important;
}

.aboutpage_sliderBox {
    max-width: 600px;
    margin: auto;
    color: #FFF;
    margin-top: 15px;
    margin-bottom: 15px;
}

.about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {
    left: 16%;
}

.about_page_slider_container_contentmt .slick_arrows_custom_logo_next {
    right: 15%
}

.about_page_slider_container_contentmt .slick_arrows_custom_logo {
    top: 40%;
}

.about_page_slider_container_contentmt .slick-dots {
    bottom: -20%;
}

.aboutpage_logoSectionHeading {
    font-size: 24px !important;
    letter-spacing: 0.18px;
    line-height: 24px;
    margin-bottom: 40px;
}

.aboutpage_containerLogo {
    max-width: 1200px !important;
    margin: auto;
}

.logo_image_button_aboutuspage {
    width: 210px !important;
    height: 210px !important;
    background: transparent !important;
    padding: 0 !important;
}

.logo_image_button_aboutuspage:focus, .logo_image_button_aboutuspage[data-focus] {
    box-shadow: none !important;
}

.logo_image_title_aboutuspage {
    font-size: 20px !important;
    letter-spacing: 0.15px;
    line-height: 20px !important;
    margin-top: 20px;
}

.logo_image_subtitle_aboutuspage {
    font-size: 14px !important;
    line-height: 17px !important;
    margin-top: 10px !important;
    text-transform: uppercase;
    margin-bottom: 20px;
}

.about_page_popupBody {
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.about_page_popupBodyTitle {
    font-size: 34px !IMPORTANT;
    line-height: 36px !important;
    margin-top: 20px;
}

.about_page_popupBodySubtitle {
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-size: 14px !important;
    line-height: 17px !IMPORTANT;
    margin-top: 15px;
    margin-bottom: 35px;
}

.about_page_popupBodyContent {
    max-width: 595px;
    letter-spacing: 0.25px;
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 300;
}

.about_page_popupBodysocialLink {
    justify-content: center;
    align-items: center;
    margin: 50px 0;
}

span.about_page_popupBodysocialLinkIcon {
    margin-right: 15px;
}

.about_page_popupBodyLink {
    color: #EC7700;
    font-size: 15px;
}

.about_page_popup {
    margin-bottom: 0 !important;
}

.eror_class {
    border-color: red !important
}

/* ================================================== Substainibilty page css =============================================== */
.substainibilitypage_container {
    max-width: 960px !IMPORTANT;
    margin: 70px auto 70px;

    text-align: left;
}

.substainablity_content {
    letter-spacing: 0.5px;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
}

.substainabilitypage_content_heading {
    font-size: 20px !important;
    text-align: left;
    margin-bottom: 5px;
    line-height: 20px !important;
}

.substainabilitypage_content_Subheading {
    font-size: 16px !important;
    line-height: 16px !important;
}

.list_Substainibility_page {
    padding-left: 15px;
    margin-top: 5px;
}

.list_Substainibility_page li {
    font-size: 16px;
    font-weight: 300 !important;
}

/* ================================================== Contact Us page css start =============================================== */
.contactus_page_container {
    max-width: 1000px !important;
    margin: auto;
}

.contactUspage_block_Details_heading {
    letter-spacing: 0.18px;
    font-size: 24px !important;
    line-height: 24px !important;
}

.contactUspage_block {
    margin-top: 50px;
    padding-bottom: 10px;
}

.contactUspage_block_Details {
    margin-top: 65px;
    text-align: left;
}

.contactUspage_block_Details_link {
    letter-spacing: 0.4px;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
}

.contactUspage_block_Details_emails {
    margin-bottom: 30px;
}

.chakra-text.contactUspage_block_DetailsContent {
    margin-top: 30px;
    margin-bottom: 5px;
}

.contactUspage_block_Details_emailsHeading {
    letter-spacing: 0.5px;
    font-weight: 700;
    font-size: 16px !important;
    line-height: 24px !important;
}

.contactUspage_block_Details_emailslink {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
}

.contactUspage_block_Details_socialIcons {
    display: flex;
    margin-left: 0 !important;
    margin-top: 10px;
}

.contactUspage_block_Details_socialIcons li {
    list-style-type: none;
    margin: 0;
    margin-right: 10px;
}

.contactUspage_block_Details_socialIconsicon svg {
    width: 24px;
    height: 24px;
}

.grey_background_drillcut {
    background: #F7F7F7;
}

.yd_signup_background {
    background: #F2F2F2;
}

.login_page_block label.sameaddr-checkbox {
    float: right;
    margin-top: 24px;
    flex-direction: row-reverse;
}

.sameaddr-checkbox .chakra-checkbox__label {
    font-size: 12px;
    margin-right: 10px;
}

.contactUspage_block_Form_block {
    padding: 70px;
}

.label_name_Contactform {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
}

.contactUspage_block_Form_block {
    padding: 45px 45px 55px;
}

.form_submit_Button {
    padding: 4px 45px;
    cursor: pointer;
}

.maps_location_heading {
    letter-spacing: 0.18px;
    font-size: 24px !important;
    line-height: 24px !important;
    margin-bottom: 25px;
}

.map_section_block {
    margin-top: 40px;
    margin-bottom: 100px;
}

.bottom_border_contactUspage {
    border-bottom: 1px solid #C4C4C4;
}

.map_content_background {
    background: #F2F2F2;
    padding: 20px 25px;
    text-align: left;
}

.contactUspage_block_Details_heading.drillcut_purple {
    letter-spacing: 0.18px;
    font-size: 24px !important;
    line-height: 24px !important;
}

.map_adreesMobile_number_address {
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
}

.map_adreesMobile_number_number {
    letter-spacing: 0.5px;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
}

.schdule_timemaps {
    letter-spacing: 0.5px;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    margin-top: 15px;
}

/* ================================================== Contact Us page css end =============================================== */
.map_heading_mt {
    font-size: 24px !important;
    line-height: 24px !important;
    letter-spacing: 0.18px;
    margin-bottom: 5px;
}

/* ================================================== Drillcut Tv page css =============================================== */
.drillcuttv_page_header_buttons {
    background: #F2F2F2;
    padding: 32px 60px;
    text-align: left;
}

.drillcuttv_page_header_buttons_btn {
    margin-right: 15px;
    padding: 10px 25px;
    text-transform: capitalize;
    font-size: 15px !important;
    line-height: 24px !important;
    margin-bottom: 15px;
}

.extra_tags_button .drillcuttv_page_header_buttons_btn {
    color: #1A1A1A;
}

.drillcut_tv_page_container {
    max-width: 1450px !important;
    margin: auto;
}

.pagination_block_mt {
    justify-content: space-between;
    padding: 20px 8px;
    align-items: center;
}

.pagination_links_ul {
    padding: 0 15px;
}

.current_pages_mt {
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
}

.paginate_items_list {
    display: flex;
}

.paginate_items_list .previous, .paginate_items_list .next {
    background: #4D4D4D !important;
    border-radius: 5px;
    width: 32px !important;
    height: 32px !important;
    box-shadow: none !important;
    padding: 0 !important;
}

.paginate_items_list .previous a, .paginate_items_list .next a {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.pagination_links_ul button {
    background: transparent !important;
}

.paginate_items_list svg {
    fill: #FFF;
    width: 16px;
    height: 16px;
}

.paginate_items_list li {
    list-style-type: none;
    background: transparent !important;
    font-size: 14px !important;
    line-height: 17px !important;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    width: 32px !important;
    height: 32px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.total_pages_tv_page {
    text-transform: uppercase;
    letter-spacing: 0.1px;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
}

.page_container_change {
    max-width: 1450px;
}

.drillcuttv_subfilters {
    background: #F2F2F2;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
}

.drillcuttv_subfilters_button_mt {
    background: #EC7700 !important;
    border-radius: 0 !important;
    letter-spacing: 0.18px;
    color: #FFF;
    font-size: 24px;
    line-height: 24px;
    padding: 26px 70px !important;
}

.drillcuttv_subfilters_checkboxes {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.drillcuttv_subfilters_checkbox {
    align-items: center;
    padding-right: 45px;
    padding-bottom: 12px;
    padding-top: 12px;
}

.drillcuttv_subfilters_checkbox_box {
    width: 24px !IMPORTANT;
    height: 24px !important;
    border-radius: 50% !important;
    background: #FFFFFF;
    border: 1px solid #E2E2E2;
    cursor: pointer;
}

.searchpagesubfilters {
    margin-bottom: 25px;
}

select#searchpage_sort {
    width: 250px !important;
    border-radius: 5px;
    border: 1px solid #C4C4C4;
}

.searchsort_box {
    margin-right: 25px;
}

.drillcuttv_subfilters_checkbox .chakra-checkbox__input {
    width: 24px !important;
    height: 24px !important;
}

.drillcuttv_subfilters_checkbox_label {
    letter-spacing: 0.15px;
    font-size: 16px;
    line-height: 24px;
    padding-left: 10px;
    cursor: pointer;
}

/* ============================================ Blog page css ============================================  */
.drop_downmenu_blogpage {
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;
    background: #F2F2F2 !important;
    border-radius: 0 !important;
    min-width: 150px !important;
    border-top: 5px solid #592C82 !important;
}

.drillcuttv_subfilters_button_mt:hover, .drillcuttv_subfilters_button_mt[data-hover] {
    background: #EC7700 !important;
}

/* ============================================ Drillcut tv page  ============================================  */

.flilters_buttondownloadpage {
    width: 100%;
    padding: 13px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
    padding-left: 40px;
    text-align: left;
    letter-spacing: 0.18px;
    font-weight: 700;
    font-size: 24px !IMPORTANT;
    line-height: 24px !important;
    color: #FFF;
}

.flilters_downloadpage {
    text-align: left;
    width: 100%;
    display: block;
    padding: 13px;
    padding-left: 40px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    border-bottom: 1px solid rgba(77, 77, 77, 0.2);
}

.download_subtags_box {
    padding: 28px 0px;
    /*padding-left: 55px;*/
    flex-wrap: wrap;
}

.tableblogdownloadspage_mt tr:nth-of-type(odd) {
    background: rgba(255, 255, 255, 0.5) !important;
}

.tableblogdownloadspage_mt tr:nth-of-type(odd) td, .tableblogdownloadspage_mt tr:nth-of-type(even) td {
    background: transparent !important;
}

.tableblogdownloadspage_mt tr:nth-of-type(even) {
    background: rgba(242, 242, 242, 0.5) !important;
}

.tableblogdownloadspage_mt tr td {
    border: none !important;
}

.tableblogdownloadspage_mt tr {
    padding: 0 15px;
    display: block;
    width: 100%;
}

.downloads_page_space {
    padding: 0 25px;
}

.downloads_page_content_mt {
    justify-content: space-between;
    align-items: center;
}

.downloads_page_content_td_mt {
    align-items: center;
}

.downloads_page_content_td_mt_heading {
    padding-left: 50px;
    letter-spacing: 0.25px;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    text-transform: capitalize;
}

.download_svg {
    display: flex;
    align-items: center;
}

.download_button_mt {
    padding: 6px 43px;
    display: flex;
}

.download_svg svg {
    display: inline;
    width: 20px !important;
    height: 20px !important;
    margin-right: 15px;
}

.extra_tags_button {
    background: transparent !important;
    color: #1A1A1A;
    font-weight: 700;
    font-size: 15px !IMPORTANT;
    line-height: 24px !important;
}

.extra_tags_button svg {
    width: 25px !important;
    height: 25px !important;
    font-weight: 700;
}

.extra_tags_button:focus, .extra_tags_button[data-focus] {
    box-shadow: none !important;
}

/* ============================================ Article page css ============================================ */
.newsletter_block_articleDrillcut {
    align-items: center;
    background: #E9EAEB;
    border-radius: 8px;
    width: 520px;
    margin-top: 15px;
}

.newsletter_block_articleDrillcutEmail input {
    color: rgba(0, 0, 0, 0.5);
    letter-spacing: 0.5px;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
}

.newsletter_block_articleDrillcutButton {
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;
    border-radius: 0px 8px 8px 0px !important;
    background: #FFF !important;
    text-transform: uppercase;
    min-width: 100px !important;
    letter-spacing: 1.25px;
    font-weight: 700;
    font-size: 14px !important;
    line-height: 16px !important;
    color: #1A1A1A;
}

.newsletter_block_articleDrillcutButton:hover {
    background: #592C82 !important;
    color: #fff;
}

.newsletter_block_articleDrillcutEmail input:focus, .newsletter_block_articleDrillcutEmail input[data-focus] {
    box-shadow: none !important;
    border-color: inherit !important;
}

.back_button {
    padding: 4px 45px;
    height: auto !important;
    text-transform: uppercase;
}

.article_last_border {
    background: #C4C4C4;
    width: 100%;
    height: 0.5px;
    padding: 0;
    margin-bottom: 50px;
}

.downloads_pagepagination {
    padding: 15px 0 !important;
}

.social_iconsArticleContent {
    justify-content: space-between;
    align-items: center;
}

.article_social_icons {
    list-style-type: none !important;
}

.article_social_icons li {
    float: left;
    width: 40px;
    height: 40px;
    margin-left: 15px !important;
}

.social_iconsArticle {
    width: 100% !important;
    height: 100% !important;
}

.drillcutArticleProductsectionminiHeading {
    color: #1A1A1A;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px !important;
    line-height: 17px !important;
}

.drillcutArticleProductsectionHeading {
    color: #1A1A1A;
    letter-spacing: 0.18px;
    font-weight: 700;
    font-size: 24px !important;
    line-height: 24px !important;
}

.drillcutProductBlock {
    margin: 50px 0;
}

.articleproducts_mt {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
}

/*.articleproducts_mt_backgroundColor {*/
/*    height: 190px;*/
/*}*/

.articleproducts_mt_backgroundColor img {
    margin: auto;
}

.articleproducts_mt_ProductImage {
    align-items: center;
    height: 100%;
}

.ArticleProductTitle.drillcut_purple {
    letter-spacing: 0.15px;
    font-weight: 700 !important;
    font-size: 20px !important;
    line-height: 24px !important;
    text-align: left;
    text-transform: capitalize;
}

.articleproducts_mt_content {
    padding: 15px;
}

.ArticleProductSku {
    letter-spacing: 1.5px;
    color: #4D4D4D;
    font-weight: 500;
    font-size: 10px !important;
    line-height: 12px !important;
    text-align: left;
}

.login_buttonArticleProduct {
    text-align: right;
    display: block;
    width: 100%;
    color: #1A1A1A;
    text-decoration: underline;
    letter-spacing: 0.18px;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 12px;
}

.ArticleProductButton {
    width: 100%;
    display: block;
    padding: 7px;
}

.articlecontent_Description {
    letter-spacing: 0.5px;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    text-align: justify;
}

.slider_gallery_images {
    width: 99% !important;
    max-width: 100%;
    display: block;
    height: 500px !important;
    background: transparent !important;
    padding: 0 !important;
}

.sliderImages {
    margin: 0 20px;
}

.slider_gallery_images img {
    max-width: 100%;
    width: 100%;
}

.gallery_slider .slick-dots li button:before, .slidergalleryModalContentgallery_slider .slick-dots li button:before {
    color: #F2F2F2 !important;
}

.gallery_slider .slick-dots li.slick-active button:before, .slidergalleryModalContentgallery_slider .slick-dots li.slick-active button:before {
    color: #EC7700 !important;
}

.gallery_slider .slick-dots, .slidergalleryModalContentgallery_slider .slick-dots {
    margin-top: 15px;
    bottom: inherit !important;
}

.slider_gallery_images_image {
    width: 100%;
    max-width: 100%;
}

.slidergalleryModalContent {
    max-width: 100% !important;
    position: relative;
}

.modal_overlayGallerySlider {
    background: #FFF !important;
}

.slickArrowArticleImageGallery {
    position: absolute;
    top: 50%;
    width: 25px;
    height: 25px;
    transform: translate(0, -50%);
    z-index: 9999;
}

.slickArrowArticleImageGallery_previous {
    left: 10%;
}

.slickArrowArticleImageGallery_next {
    right: 10%;
}

.slickArrowArticleImageGallery svg {
    width: 100%;
    height: 100%;
    fill: #FFF;
}

.more_articles_heading {
    letter-spacing: 0.18px;
    font-weight: 700;
    font-size: 24px !important;
    line-height: 24px !important;
    color: #1A1A1A;
    margin-bottom: 35px;
    text-transform: capitalize;
}

.paginate_items_list li.pagination__link--disabled {
    background: rgb(77 77 77 / 50%) !important;
}

.downloads_page_content_mt {
    padding: 30px 10px !important;
}

.table_downloads {
    margin-bottom: 35px;
}

.downloads_page_content_mt td {
    padding: 0 !important;
}

/* ============================================ Search Page =============================================== */
.search_page_main_filter {
    background: #592C82;
    width: 100%;
    display: block;
}

.drllcutfilterLink {
    color: rgba(255, 255, 255, 0.5);
    letter-spacing: 0.15px;
    font-weight: 700 !important;
    font-size: 20px !important;
    line-height: 24px !important;
    background: transparent !important;
}

.drillcutFilters {
    padding: 28px 0;
}

.drllcutfilterLink {
    box-shadow: none !Important;
}

.searchpageFilterContainer {
    max-width: 1260px !important;
    margin: auto;
}

.search_page_main_filter {
    border-top: 1px solid #FFF;
}

.drillcutFilters_boxShadow {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

.searchFilterbuttonDefault {
    margin-top: 25px;
}

.searchsubfilterAccordinButton:focus, .searchsubfilterAccordinButton[data-focus] {
    box-shadow: none !important;
}

.searchsubfilterAccordinButton:hover, .searchsubfilterAccordinButton[data-hover] {
    background: transparent !important;
}

.accordianSubFilters {
    background: #F2F2F2;
    padding: 20px 30px;
}

.accordianItem {
    border: none !important;
}

.mainAccordianHeading {
    letter-spacing: 0.15px;
    color: #000000;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
}

.accordian_Content {
    margin-top: 20px;
}

.searchProductsGrid {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.productImageBackground {
    height: 200px;
    background: #F2F2F2;
    justify-content: center;
    align-items: center;
}

.productImageBackgroundImage {
    width: 200px;
}

.drillcutsearchMainResult {
    padding: 10px 35px 35px 20px;
}

.productContent {
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.SeacrhpageproductTitle {
    letter-spacing: 0.15px;
    font-weight: 700;
    font-size: 20px !important;
    line-height: 24px !important;
    text-align: left;
    margin-bottom: 18px;
    display: block;
    text-transform: capitalize;
}

.viewproductsButtonSearchpage {
    width: 100% !important;
    display: block;
    padding: 8px;
}

.SearchBlogGrid {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

.gallerySliderCloseButton {
    top: -17px !important;
    z-index: 99;
    background: #FFF !important;
    border-radius: 50% !important;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
    right: 0 !important;
}

/*  */
.modalSearchButton {
    display: block !important;
    padding: 0 !important;
    background-color: transparent !important;
}

.SearchModalOpenContent {
    width: 100% !important;
    display: block !important;
    max-width: 100% !important;
    margin: 0 !important;
    border: none !important;
    border-radius: 0 !important;
}

.aa-panel {
    z-index: 9999 !important;
}

#search_mt {
    display: none;
}

.create-dropdown > div:not(.no-width) {
    width: 90%;

}

/* ============================================ Search Page view ============================================  */
.searchBox_searchPage {
    position: relative;
}

.searchBox_searchPage input.ais-SearchBox-input {
    border: 1px solid rgba(0, 0, 0, 0.25) !important;
    height: 40px;
    border-right: 0;
    border-radius: 8px;
    padding: 10px 15px;
    box-shadow: none;
    font-size: 16px;
    vertical-align: top;
    width: 100%;
    max-width: 430px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

/*button.ais-SearchBox-reset {*/
/*    display: none;*/
/*}*/

.searchDatamt ul {
    list-style-type: none !important;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
}

.searchDatamt ul li {
    width: 100%;
}

.search_blog_design_mt {
    margin: 0 !important;
}

.refinementcss ul {
    list-style-type: none;
    text-align: left;
}

.drillcut_tv_play_icon:focus, .drillcut_tv_play_icon[data-focus] {
    box-shadow: none !important;
}

.DownloadSearchMt ul {
    width: 100%;
    list-style-type: none;
}

.searchpageDownloadsImageBox {
    width: 80px;
    height: 80px;
}

.searchpageDownloadsImageBox img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.DownloadSearchMt ul li:nth-of-type(even) {
    background: rgba(242, 242, 242, 0.5) !important;
}

.DownloadSearchMt ul li:nth-of-type(odd) {
    background: rgba(255, 255, 255, 0.5) !important;
}

.searchBox_searchPage form.ais-SearchBox-form {
    display: flex;
    justify-content: center;
    align-items: center;
}

a.login_button_tab {
    text-decoration: underline;
    color: rgba(26, 26, 26, 0.5);
    letter-spacing: 0.18px;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
}

.searchBox_searchPage .ais-SearchBox-submit {
    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: #FFF;
    font-family: acumin-pro, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px !important;
    line-height: 16px;
    border: 1px solid;
    border-color: #592C82;
    background: #553C9A;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-items: center;
    padding: 0 25px;
    border-radius: 8px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.searchBox_searchPage .ais-SearchBox-input:focus-visible {
    outline: none !important;
}

.drllcutfilterLink[aria-selected="true"] {
    color: #FFF !important;
    border: none !important;
}

.drllcutfilterLink {
    border: none !important;
}

.searchPage_pagination ul.ais-Pagination-list {
    list-style-type: none;
    display: flex;
    justify-content: flex-end;
}

.searchPage_pagination .ais-Pagination-item--firstPage {
    display: none;
}

.searchPage_pagination .ais-Pagination-item--previousPage,
.searchPage_pagination .ais-Pagination-item--nextPage {
    background: #4D4D4D !important;
    border-radius: 5px;
    width: 32px !important;
    height: 32px !important;
    box-shadow: none !important;
    padding: 0 !important;
}

.searchPage_pagination .ais-Pagination-item--disabled {
    background: rgb(77 77 77 / 50%) !important;
}

.searchPage_pagination .ais-Pagination-link {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    letter-spacing: 0.1px;
    line-height: 17px;
    font-weight: 700;
}

.searchPage_pagination .ais-Pagination-link svg {
    fill: #FFF;
    width: 16px;
    height: 16px;
}

.searchPage_pagination {
    padding: 20px 35px 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.searchPage_pagination_bottom {
    padding: 0px 35px 20px 20px;
}

.paginate_count {
    font-weight: bold;
}

.searchPage_pagination .chakra-select__wrapper {
    width: 250px;
}

.searchPage_pagination .ais-Pagination {
    margin-left: 40px;
}

.searchPage_pagination .ais-Pagination-item--page {
    list-style-type: none;
    background: transparent !important;
    font-size: 14px !important;
    line-height: 17px !important;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    width: 32px !important;
    height: 32px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.searchPage_pagination .ais-Pagination-item--page.ais-Pagination-item--selected {
    background: #EC7700 !important;
    border-radius: 5px;
    box-shadow: none !important;
}

.tab_data_search {
    position: relative;
}

.tab_data_search[aria-expanded="true"] .arrowactivetabsearch {
    width: 0;
    height: 0;
    border-right: 9px solid transparent;
    border-left: 9px solid transparent;
    border-bottom: 9px solid #FEFEFE;
    position: absolute;
    top: -9px;
}

div#one[aria-expanded="true"] .arrowactivetabsearch {
    left: 18.5%;
}

div#two[aria-expanded="true"] .arrowactivetabsearch {
    left: 39%;
}

div#three[aria-expanded="true"] .arrowactivetabsearch {
    left: 59.5%;
}

div#four[aria-expanded="true"] .arrowactivetabsearch {
    left: 79.5%;
}

.ProductImageSearchPage {
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 13;
    min-height: 200px;
    object-fit: cover;
}

img.backgorund_latest_prod_mt_image {
    width: 320px;
    height: 100%;
    object-fit: cover;
}

.ais-Pagination-list--noRefinement, .ais-Pagination--noRefinement {
    display: none !important;
}

input.ais-RefinementList-checkbox {
    background: #FFFFFF;
    border: 1px solid #E2E2E2;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    margin-right: 15px;
    cursor: pointer;
}

label.ais-RefinementList-label {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
}

span.ais-RefinementList-labelText {
    letter-spacing: 0.15px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
}

span.ais-RefinementList-count:before {
    display: inline;
    content: "(";
}

span.ais-RefinementList-count:after {
    display: inline;
    content: ")";
}

.Sort_pagination {
    display: flex;
    align-items: center;
}

body.scrolllock {
    position: fixed;
    width: 100%;
    overflow-y: scroll;
}

.icons_with_text_button {
    background: transparent !important;
    align-items: center;
    justify-content: center;
    margin: 0 !IMPORTANT;
}

.icons_with_text_button a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 400;
}

.header_icons_mt_new_Drillcut {
    width: 35px !important;
    height: 35px !important;
}

/* ============================================ Collections Page Css ======================================= */
.CollectionsBrowse {
    width: 100% !important;
    border-radius: 0 !important;
    letter-spacing: 0.18px;
    font-size: 24px !important;
    line-height: 24px !important;
    padding-left: 40px !important;
    text-align: left !important;
    justify-content: start !important;
}

.Collection_title_filter {
    justify-content: space-between !important;
    letter-spacing: 0.15px;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    padding: 13px 25px !important;
    padding-left: 40px !important;
}

.Collection_title_filter:hover, .Collection_title_filter[data-hover] {
    background: inherit !important;
}

.Collection_title_filter:focus, .Collection_title_filter[data-focus] {
    box-shadow: none !important;
}

.Subcollection_link_button {
    display: block;
    padding-left: 40px;
    text-align: left;
    letter-spacing: 0.5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 34px;
}

.CollectionsData {
    display: flex;
}

.collection_grid {
    padding: 40px 35px 35px 20px;
}

.collectiongrid_item {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
}

.collectionImage {
    width: 100%;
    height: 230px;
}

.collectionImage img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.collection_title_collectionPage {
    font-size: 20px !important;
    letter-spacing: 0.15px;
    font-weight: 700 !important;
    line-height: 24px !important;
    padding: 15px;
}

.drillcuttvFiltersTvpage {
    justify-content: start;
    flex-wrap: wrap;
}

.drillcutSecondLineFilters {
    margin-top: 15px;
}

.subcollectionButton {
    border: none !important;
}

.mini_sub_title_data {
    padding-top: 0 !important;
}

.subcollection_title_filter {
    padding-right: 10px !important;
    font-weight: 400 !important;
}

.CollectionsBrowse:hover {
    background: #EC7700 !important;
    color: #FFF !important;
    border: none !important;
}

.SelectCategoryRow {
    background: #F2F2F2;
    display: flex;
}

.selectbox_Box_category {
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.5);
    font-weight: 700;
    padding: 0 19.5px !important;
    padding-top: 19.5px !important;
    font-size: 14px !important;
    line-height: 17px !important;
    letter-spacing: 0.1px;
    text-align: left;
}

.selectbox_Box {
    width: 20%;
    padding-left: 40px;
    padding-bottom: 19.5px;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
}

.selectbox_Box_select {
    border: none !important;
    letter-spacing: 0.15px;
    font-weight: 700;
    font-size: 20px !important;
    line-height: 20px !important;
    height: auto !important;
    cursor: pointer;
}

.SearchNormalBox {
    display: flex;
    justify-content: center;
    align-items: center;
}

.search_button_home {
    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: #FFF;
    font-family: acumin-pro, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px !important;
    line-height: 16px;
    border: 1px solid;
    border-color: #592C82;
    background: #553C9A;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-items: center;
    padding: 0 25px;
    border-radius: 8px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.selectbox_Box_select:focus, .selectbox_Box_select[data-focus] {
    box-shadow: none !important;
}

.CollectionsBrowse:focus, .CollectionsBrowse[data-focus] {
    box-shadow: none !important;
}

/* Cart page */
.quantity_buttons_cart_page {
    background: #F2F2F2;
    border-radius: 5px;
    width: 160px;
    margin: 0;
}

.buttons_cartPage_inc_dec {
    padding: 13px;
    width: 45px;
}

.decrement_cartButton {
    border-right: 1px solid rgba(196, 196, 196, 0.5);
}

.increment_cartButton {
    border-left: 1px solid rgba(196, 196, 196, 0.5);
}

.cart_page_quantity_input {
    width: 70px !important;
    text-align: center;
    letter-spacing: 0.18px;
    color: #1A1A1A;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    border: none !important;
}

.checkout_button_css_mt {
    display: flex;
    justify-content: center;
    align-items: center;
}

.articleproducts_mt_ProductImage img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.react_player_full_width {
    width: 100% !important;
    max-width: 100% !important;
    display: block;
}

.react_player_mt {
    width: 100% !important;
    max-width: 100% !important;
    display: block;
    height: 78vh !important;
}

.aa-Panel {
    z-index: 150;
}

.aa-Form {
    width: 100%;
}

.drill-cut-link-active li {
    border-left: 8px solid #F58220 !important;
    color: #F58220 !important;
}

.external_html ul {
    list-style-type: initial;
    margin-inline-start: 1em;
}

.external_html h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    text-align: left;
    letter-spacing: 0.18px;
    color: #1A1A1A;
    padding: 25px 0px 20px;
}

.external_html h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: left;
    letter-spacing: 0.18px;
    color: #1A1A1A;
    padding: 25px 0px 20px;
}

.smcx-embed {
    margin: auto;
}

/* ============================================ Responsive view ============================================  */

@media (max-width: 1500px) {
    .slider_content_home {
        padding-left: 20px !important;
        padding-right: 20px !important;
    }

    .slick_slider_custom_arrows, .home_page_main_slider_mt .slick-dots {
        top: 65%;
        padding-left: 50px;
    }

    .slick_left_arrow {
        left: 3%;
    }

    .slick_right_arrow {
        left: 28%;
    }

    .main_container {
        padding: 0 30px !important;
    }

    span.icons_with_text_button_text {
        display: none;
    }
}

@media (max-width: 1025px) {
    .react_player_mt {
        height: 300px !important;
    }

    .footer_menu_content_contain {
        padding-right: 40px;
    }

    .icons_with_text_heading_home_mt, .text_main_home_mt {
        width: 100% !important;
    }
}

.video_block_bg_img img {
    cursor: pointer;
}

@media (max-width: 1025px) {
    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {
        right: 10%;
    }

    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {
        left: 10%;
    }
}

@media (max-width: 950px) {
    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {
        right: 5%;
    }

    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {
        left: 5%;
    }

    img.logo_width_set {
        width: 80%;
    }

    .header_center_mt {
        align-items: center;
    }

    .footer_menu_content_contain {
        padding-right: 20px !important;
    }

    .footer_divider {
        margin-right: 30px !important;
        margin-left: 20px !important;
    }

    .policies-content {
        width: 100%;
        padding: 0px 20px;
    }
}

/* tabview  */
@media (max-width: 769px) {
    .searchBox_searchPage {
        margin: 0 !important;
        padding: 0px 20px 15px;
    }

    .hamburger_menu_icon {
        background: transparent !important;
        color: #000;
        outline: none !important;
    }

    .hamburger_menu_icon svg {
        width: 25px;
        height: 25px;
        color: #000;
        font-weight: 600;
    }

    .hamburger_menu_icon:focus, .hamburger_menu_icon[data-focus] {
        box-shadow: none !important;
    }

    .drill_cut_tv_popup {
        max-width: 95% !important;
    }

    .drillcuttv_popup_close_btn {
        right: -5px !important;
        top: -25px !important;
    }

    .gallerySliderCloseButton {
        top: -6% !important;
        right: 0;
        border-radius: 50% !important;
        background: #FFF !important;
        z-index: 9;
        box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);
    }

    .clearallfilters_mt_btn {
        margin-top: 20px !important;
    }

    .filter_select_box {
        margin-top: 20px;
    }

    .background_image_mt_content_main {
        padding-left: 30px;
    }

    .main_container {
        padding: 0 15px;
    }

    .slider_components_mt {
        flex-direction: column;
    }

    .drllcutfilterLink {
        font-size: 11px !important;
        padding-top: 10px;
        padding-bottom: 5px;
    }

    .drllcutfilterLink span {
        display: block;
        margin-top: -10px;
    }

    .drillcutsearchMainResult {
        padding: 25px 20px !important;
    }

    .drillcutreusultcount {
        font-size: 24px !important;
        padding: 20px 15px !important;
    }

    .searchDrillcutfilters {
        padding: 0 0 10px 0 !important;
    }

    .main_slider_home_content_mt {
        padding: 25px !important;
        margin-bottom: 87px;
    }

    .main_slider_home_content_main {
        order: 1;
    }

    .half_mini_width_drillcut {
        width: 100%;
    }

    .box_view_design_mt, .latest_product_contain, .blog_section_drillcut {
        flex-direction: column;
    }

    .box_design {
        margin: 15px 0 0;
        background-size: 100%;
        height: 180px;
        background-repeat: no-repeat;
    }

    .box_homepage_designs_content {
        bottom: 8%;
    }

    .box_homepage_designs_heading {
        font-size: 24px !important;
        line-height: 5px !important;
    }

    .backgorund_latest_prod_mt {
        height: 250px;
    }

    .icons_with_text_heading_home_mt_logo svg {
        width: 25px;
        height: 25px;
    }

    .half_width_class_mt {
        width: 100%;
    }

    .slider_component_box {
        order: 1;
        height: 350px;
    }

    .slider_content_home {
        padding: 20px !important;
        height: 100%;
    }

    .home_page_main_slider_mt .slick-dots {
        width: 100%;
        bottom: 35px !important;
        top: unset !important;
        padding-left: 50px;
    }

    .slick_slider_custom_arrows {
        bottom: 35px !important;
        top: unset !important;
    }

    .main_container_mt {
        padding: 0 15px !important;
    }

    .slick_left_arrow {
        left: 5%;
    }

    .latest_product_div_mt {
        margin: 15px 0;
        flex-direction: column;
        height: 100%;
    }

    .blog_design_mt {
        margin: 15px 0;
    }

    .slick_right_arrow {
        left: 36%;
    }

    /*.slider_image_mt {*/
    /*    height: 200px;*/
    /*}*/
    .icons_with_text_heading_home_mt {
        width: 100% !important;
        padding: 0 15px;
    }

    .text_main_home_mt {
        padding: 0 15px;
    }

    .Background_color_schema_div {
        padding: 50px 0 50px;
    }

    .logo_text_block_contain {
        justify-content: flex-start;
    }

    .slick_arrows_custom_blog {
        position: absolute;
        top: 3px;
    }

    .background_image_mt_content_main_text {
        max-width: 270px;
    }

    .slick_arrows_custom_blog svg {
        width: 20px;
        height: 20px;
        fill: #592C82;
    }

    .slick_arrows_custom_blog_previous {
        left: 25%;
    }

    .slick_arrows_custom_blog_next {
        right: 27%;
    }

    .custom_dots_blog {
        position: relative;
    }

    .blog_section_home_button {
        margin-top: 60px;
    }

    .background_image_mt_content {
        left: 0;
        padding: 15px;
    }

    .blog_section_home_button_div {
        margin-bottom: 0;
    }

    .drill_cut_tv_Homemt {
        padding-bottom: 40px !important;
    }

    .slick_arrows_custom_logo {
        width: 30px;
        height: 30px;
    }

    .text_logo_section_logo_mt {
        grid-gap: 30px 5px;
    }

    .logo_icons_logo_mt {
        height: auto;
    }

    .Logo_icons_full_width {
        padding: 0;
    }

    .text_logo_section_logo_mt {
        grid-gap: 25px 0 !important;
    }

    .blog_section_mobile_slider .slick-dots li button::before, .slider_instafeed .slick-dots li button::before {
        color: #F2F2F2 !important;
    }

    .blog_section_mobile_slider .slick-dots li.slick-active button:before, .slider_instafeed .slick-dots li.slick-active button:before {
        color: #EC7700 !important;
    }

    .logo_icons_logo_mt img {
        max-width: 80%;
    }

    .logo_icons_logo_mt {
        margin: 40px 0 15px;
    }

    .background_image_mt_container {
        left: 0;
        padding: 25px;
    }

    .latest_product_heading {
        margin-bottom: 25px;
    }

    .instagram_slider {
        margin-top: 30px;
    }

    .slider_instafeed .slick_arrows_custom_blog_previous {
        left: 20%;
    }

    .slider_instafeed .slick_arrows_custom_blog_next {
        right: 20%;
    }

    .slider_instafeed .slick-dots {
        bottom: -40px;
    }

    .slider_instafeed .slick_arrows_custom_blog {
        top: 18px;
    }

    /* ========================================== About Us page Drillcut mobile_view ============================================ */
    .about_announcment_container {
        padding: 23px 0;
    }

    .pages_announment_bar_heading {
        font-size: 24px !important;
        line-height: 24px;
        text-align: left;
        padding: 0 20px;
        line-height: 30px !important;
    }

    .pages_announment_bar_sub_heading {
        padding: 0 20px;
    }

    .about_container {
        padding: 0 20px !important;
    }

    .about_us_content_mt {
        max-width: 100%;
        margin: 20px 0;
        letter-spacing: 0.5px;
        font-size: 16px;
        line-height: 24px;
    }

    .video_about_mt {
        margin-bottom: 45px;
    }

    .about_us_brands_heading {
        margin-bottom: 40px !important;
    }

    .about_2_box {
        padding: 0 !important;
    }

    .brand_logo_aboutuspage {
        margin-bottom: 30px;
    }

    .heading_image_withtext_about {
        margin-top: 30px;
    }

    .button_mt_about {
        width: 203px;
    }

    .aboutus_imagewithtext_Box {
        margin-bottom: 30px;
    }

    .about_slider_bg_image_mt {
        margin-top: 40px;
        min-height: 451px;
    }

    .about_us_page_slider {
        max-width: 100% !important;
    }

    .about_us_page_sliderContent {
        font-size: 24px;
        line-height: 24px;
    }

    .about_page_slider_container_mt_heading {
        font-size: 24px !important;
    }

    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {
        right: -2%;
    }

    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {
        left: -2%;
    }

    .aboutpage_sliderBox {
        max-width: 260px;
    }

    .logo_image_button_aboutuspage {
        width: 140px !important;
        height: 140px !important;
    }

    .substainibilitypage_container {
        margin: 25px 0 25px;
    }

    .main_slider_home_heading_mt {
        font-size: 18px !important;
        line-height: 22px !important;
        max-width: 90%;
    }

    .about_page_popupBody img {
        width: 180px !important;
        height: 180px !important;
    }

    .contactUspage_block {
        flex-direction: column;
        margin-top: 25px
    }

    .width_40DrillCut, .width_60DrillCut, .width_25DrillCut, .width_75DrillCut, .box_width_70, .box_width_30 {
        width: 100%;
    }

    .downloads_pageContainer {
        flex-direction: column;
    }

    .contactUspage_block_Details {
        margin-top: 0;
        padding: 0px 20px;
    }

    .container_padding_remove {
        padding: 0 !important;
    }

    .contactUspage_block_Form_block {
        padding: 40px 20px;
    }

    .bottom_border_contactUspage {
        margin: 0 20px;
    }

    .drillcuttv_page_header_buttons {
        padding: 20px;
    }

    .drillcuttv_subfilters_button_mt {
        font-size: 14px !important;
        text-transform: uppercase;
        font-weight: 600 !important;
        padding: 15px !important;
        justify-content: space-between;
    }

    .css-1ygl3x:focus, .css-1ygl3x[data-focus] {
        box-shadow: none !important;
    }

    .accordin_content_mobileview {
        padding: 0 !important;
    }

    .accordin_content_mobileview_heading {
        letter-spacing: 0.15px;
        font-size: 20px !important;
        line-height: 24px !important;
        padding: 15px 0;
        text-align: left;
    }

    .filter_select_box {
        background: #FFFFFF;
        border-radius: 4px;
        padding: 15px;
        position: relative;
    }

    .filter_select_box_heading {
        color: rgba(0, 0, 0, 0.5);
        letter-spacing: 0.1px;
        text-transform: uppercase;
        font-size: 10px !important;
        line-height: 12px !important;
        font-weight: 700 !important;
        text-align: left;
    }

    select#tag_onchange_mobile {
        border: none;
        padding: 0 !important;
        letter-spacing: 0.15px;
        font-weight: 700;
        font-size: 16px !important;
        line-height: 24px !important;
        height: auto !important;
        width: 100%;
    }

    .css-k7r2wc:focus, .css-k7r2wc[data-focus] {
        box-shadow: none !important;
    }

    .clearallfilters_mt_btn {
        width: 100% !important;
        background: #4D4D4D !important;
        border-radius: 5px !important;
        color: #FFF;
        font-weight: 700 !important;
        font-size: 12px !important;
        line-height: 12px !important;
        margin-bottom: 20px;
    }

    .clearallfilters_mt_btn:hover {
        background: #4D4D4D !important;
    }

    .filter_select_box_checkbox {
        padding: 0 !important;
        justify-content: space-between;
    }

    .filter_select_box_checkbox_heading {
        letter-spacing: 0.15px;
        font-size: 16px !important;
        line-height: 24px !important;
        justify-content: space-between;
    }

    .drillcuttv_subfilters_checkbox {
        margin: 15px 0;
    }

    .filter_select_box_checkbox:hover, .filter_select_box_checkbox[data-hover] {
        background: transparent !important;
    }

    .slider_gallery_images {
        width: 100% !important;
    }

    .sliderImages {
        margin: 0 !important;
    }

    .slider_gallery_images {
        height: auto !important;
    }

    .mobileviewimagewithtextArticle {
        padding: 50px 20px 10px !important;
    }

    .newsletter_block_articleDrillcut {
        width: 100% !important;
    }

    .newletterContent {
        width: 100%;
    }

    .social_iconsArticleContent {
        flex-direction: column;
    }

    .article_social_icons {
        margin-top: 40px;
    }

    .article_last_border {
        margin-bottom: 40px;
    }

    .back_button {
        width: 130px !important;
    }

    .downloads_page_content_mt {
        flex-direction: column;
    }

    .tableblogdownloadspage_mt tr {
        padding: 0 !important;
    }

    .downloads_page_space {
        padding: 0 20px !important;
    }

    .downloads_pagepagination {
        padding: 20px 0 !important;
    }

    .downloads_page_content_mt {
        padding: 30px 0 !important;
        align-items: unset !important;
    }

    .download_button_mt {
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

    #tag_onchange_mobile {
        cursor: pointer;
    }

    .back_button {
        margin-bottom: 20px;
    }

    /*  Search page mobile view */
    .searchmobileviewmt {
        flex-direction: column;
    }

    .drllcutfilterLink {
        flex-direction: column;
    }

    .searchDrillcutfilters {
        overflow: hidden;
    }

    .searchDatamt ul {
        grid-template-columns: repeat(1, 1fr);
    }

    #tag_onchange_mobile:focus-visible {
        outline: none !important;
    }

    #tag_onchange_mobile:focus {
        background: transparent !important;
    }

    div#one[aria-expanded="true"] .arrowactivetabsearch {
        left: 12.5%;
    }

    div#two[aria-expanded="true"] .arrowactivetabsearch {
        left: 36.5%;
    }

    div#four[aria-expanded="true"] .arrowactivetabsearch {
        left: 82.5%;
    }

    .searchBox_searchPage input.ais-SearchBox-input {
        width: 100%;
    }

    .SearchNormalBox {
        width: 100% !important;
    }

    .CollectionsData {
        flex-direction: column;
    }

    .selectbox_Box {
        width: 100%;
    }

    .collection_grid {
        padding: 20px;
    }


    .pagination_top {
        display: none;
    }

    .searchPage_pagination_bottom {
        padding: 0px 20px 20px 20px;
        flex-wrap: wrap;
        flex-direction: column-reverse;
    }

    .paginate_count {
        width: 100%;
    }

    .Sort_pagination {
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;
    }

    .searchPage_pagination .ais-Pagination {
        margin-left: 0px;
    }

    .searchPage_pagination .ais-Pagination-item--previousPage, .searchPage_pagination .ais-Pagination-item--nextPage {
        background: #ec7700 !important;
    }

    .searchPage_pagination .ais-Pagination-item--disabled {
        background: #ec770080 !important;
    }
}

@media (max-width: 390px) {
    .slider_component_box {
        height: 320px;
    }

    .home_page_main_slider_mt .slick-dots {
        bottom: 7% !important;
    }

    .slick_slider_custom_arrow {
        margin-top: 4px;
    }
}


/* rs css start */
.container_padding_remove_rs {
    padding: 0px !important;;
}

.text_bg_login {
    /* background: url(../images/login_page.jpg); */
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    position: relative;
    background-position: bottom;
    background-size: cover;
    height: 830px;
    padding-top: 100px !important;

}

.form-login h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* identical to box height, or 100% */


    text-align: center;
    letter-spacing: 0.18px;

    color: #000000;
    padding-top: 70px;
    /*padding-bottom: 40px;*/
}

.form-mail-lg {
    margin-bottom: 21px;
}

.form-login p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    /* or 133% */


    letter-spacing: 0.4px;

    color: #000000;
    padding-top: 10px;
    text-align: left;
}

.form-login input {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
    max-width: 310px;
    border: 1px solid #C4C4C4;
}

.form-login input:focus,
.form-login input[data-focus] {


    border-color: transparent !important;
    box-shadow: 0 0 0 1px transparent !important;
}

.form_login_Button {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 15px !important;
    line-height: 56px !important;
    margin-right:0px !important;
    /* or 373% */


    align-items: center;
    text-align: center;
    transition: all 0.3s ease-in;
    color: #FFFFFF;
    height: 64px;
    width: 100%;
    margin: 22px 0px 17px;
    cursor: pointer;
}

.form_login_Button:hover {
    background-color: #000;
    color: #EC7700;
    transition: all 0.3s ease-in;
}

.text_bg_login:before {
    position: absolute;
    content: '';
    height: 100%;
    width: 100%;
    /* background-blend-mode: multiply; */
    /*background-color: rgb(89 44 130 / 85%);*/
    display: block;
    background-blend-mode: multiply;
    transform: matrix(-1, 0, 0, 1, 0, 0);
    top: 0px;
}


.form-login {
    position: relative;
    background: #F2F2F2;
    max-width: 500px;
    width: 100%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    margin: 0px auto;
    display: block;
    padding: 0px 95px;
}

.form-login label {
    /* font-family: 'Acumin Pro'; */
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */


    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;
}

.ct_acc {
    font-weight: 700;
    font-size: 15px;

    align-items: center;
    text-align: center;
    color: #EC7700;
    transition: all 0.3s ease-in;
}

.ct_acc:hover {
    color: #000;
    transition: all 0.3s ease-in;
}

.ct_ft_pw {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    align-items: center;
    text-align: center;
    text-decoration-line: underline;
    color: #EC7700;
    margin-top: 22px;
    display: block;
    transition: all 0.3s ease-in;

}

.ct_ft_pw:hover {
    color: #000;
    transition: all 0.3s ease-in;
}


.form_dt_ft {
    padding-bottom: 65px;
}

/* signup page css start */
.signuppage_block {
    padding: 75px 0px;
}

.login_block_Details {
    text-align: left;
}

.login_block_Details p {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */

    letter-spacing: 0.5px;

    color: #000000;
    padding-bottom: 15px;
}

.signup_heading {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 20px !important;
    line-height: 24px !important;
    letter-spacing: 0.15px;
    padding-bottom: 17px;

}

.list_dt {

    list-style-type: none !important;
    padding: 0px;
    margin: 0px;
    margin-inline-start: 0em !important;
}

.list_dt li {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 30px;
    letter-spacing: 0.1px;

    color: #000000;
}

.list_dt .chakra-icon {
    margin-right: 7px;
}

.fllo_signpage {

    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: 0.5px;
    color: #000000;
    padding-top: 60px;
}

.folow_icon_block svg {
    color: #000000;
    font-size: 19px;
}

.login_page_block h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    /* display: flex; */
    /* align-items: center; */
    text-align: center;
    letter-spacing: 0.18px;
    color: #000000;
    padding: 35px 0px 22px;
}

.login_page_block {
    padding: 0px 28px;
}

.login_page_block label {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height, or 133% */

    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    text-transform: uppercase;

    color: #000000;

}

.login_page_block input {
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 5px;
}

.exits_custm {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;


    letter-spacing: 0.25px;
    color: #000000;
    text-align: left;
    padding-left: 9px;
    padding: 20px 0px 10px 9px;
}

.sign_info {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 24px !important;
    line-height: 24px !important;
    text-align: center;
    letter-spacing: 0.18px;
    color: #000000;
    padding: 50px 0px 36px;
}

.pw_az {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: #000000;
    text-align: left;
    padding: 20px 0px 45px 9px;
}

.signup_submit_Button {
    height: 45px !important;;
    padding: 4px 45px !important;
    transition: all 0.3s ease-in;
    /*margin-bottom: 71px;*/
}

.signup_submit_Button:hover {
    background-color: #000;
    color: #EC7700;
    transition: all 0.3s ease-in;
}


/* rs media query  */
@media (max-width: 991px) {
    .text_bg_login {
        background: none;
        background-color: #F2F2F2;
    }

    .text_bg_login:before {
        background-color: #F2F2F2;
    }

    .form-login {
        box-shadow: none;
    }

    .form-login {
        padding: 0px 32px;
    }

    .form-login input {
        max-width: 100%;
    }

    .form-login h2 {
        padding-top: 0px;
    }

    .text_bg_login {

        height: 608px;
        padding-top: 80px !important;
        border-bottom: 2px solid #E6E6E6;
    }
}

@media (max-width: 768px) {
    .signuppage_block {
        flex-direction: column;
        padding: 35px 0px;

    }

    .login_block_Details {
        padding: 0px 42px;
    }

    .login_block_Details p {
        padding-bottom: 30px;
    }

    .signup_heading {
        padding-bottom: 9px;
    }

    .fllo_signpage {

        padding-top: 20px;
    }

    .form_lg_pdt {
        padding-top: 20px;
    }

    .exits_custm {
        padding: 10px 0px 10px 9px;
    }

    .sign_info {
        padding: 20px 0px 26px;
    }

    .pd_btmuser {
        padding-bottom: 0px;
    }
}

.error-show {
    color: red;
    text-align: initial;
    font-size: 10px;
    text-transform: uppercase;
    margin-left: 15px;
}

.checkbox-circle {
    appearance: none;
    border: 1px solid #a4a4a4;
}

.checkbox-circle:checked {
    background-color: #0075ff;
    box-shadow: inset 0 0 0 3px #FFFFFF;
    border-color: #0075ff;
}

/* product page sign in modal */
.product_sign_in .text_bg_login {
    height: auto !important;
    padding: 0 !important;
    background-color: #fff !important;
}

#chakra-modal-product_sign_in_popup {
    background-color: #f2f2f2 !important;
}

#chakra-modal-product_sign_in_popup .form_dt_ft {
    text-align: center;
}

#chakra-modal-product_sign_in_popup .form-login {
    box-shadow: unset !important;
}

.grid-product-downloads {
    grid-template-columns: auto auto auto;
}

.viewmore-btn {
    background: #EC7700 !important;
    color: #FFF !important;
}

@media (min-width: 991px) and  (max-width: 1200px) {
    .grid-product-downloads {
        grid-template-columns: auto auto;
    }
}

.main_container.header_center_mt.css-1olzamh >.css-0{
    max-width: 240px;
    width:100%;
  }
  .footer_logo_main.css-8j73os >.css-0{
    max-width: 240px;
    width: 100%;
  }


  .aa-Panel {
      display: none;
  }

    .custom-aa-Panel.aa-Panel {
        display: block;
    }

    .aa-InputWrapper {
        padding-left: 10px;
    }

.aa-Input::placeholder {
    color: #454141;
}

.aa-Label {
    background-color: #553C9A;
}

.aa-SubmitIcon {
  color: white !important;
}

.aa-Form {
    border-radius: 12px 12px 12px 12px !important;
}

.aa-Label {
    border-radius: 0px 10px 10px 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/mandasastyle.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA,mBAAmB;AACnB;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;IAC9C,cAAc;IACd,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;;AAEnB;IACI,eAAe;IACf,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA,kBAAkB;AAClB,kBAAkB;AAClB,uBAAuB;AACvB,IAAI;;AAEJ;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;IAC9C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;IAC9C,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,mBAAmB;IACnB,8CAA8C;AAClD;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,kCAAkC;IAClC,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;IACpE,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA,mHAAmH;;AAEnH;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA,+HAA+H;AAC/H;IACI,2BAA2B;IAC3B,sBAAsB;;IAEtB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA,iIAAiI;AACjI;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,+HAA+H;AAC/H;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,4HAA4H;AAC5H;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,6GAA6G;AAC7G;IACI,oDAAoD;IACpD,8BAA8B;IAC9B,2BAA2B;IAC3B,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;AAClC;;AAEA,iHAAiH;;AAEjH;IACI,WAAW;IACX,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,+GAA+G;AAC/G;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oDAAoD;IACpD,yCAAyC;IACzC,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,wCAAwC;AACxC,qBAAqB;AACrB,IAAI;;AAEJ;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,6GAA6G;AAC7G;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA,KAAK;AACL;IACI,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;;AAEd;;AAEA,gHAAgH;AAChH;IACI,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;IAChD,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA,+BAA+B;AAC/B,qBAAqB;AACrB,IAAI;;AAEJ;IACI,gCAAgC;IAChC,aAAa;IACb,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,8GAA8G;AAC9G;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;IACtB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IAExB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA,+GAA+G;;AAE/G;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,QAAQ;QACR,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA,aAAa;AACb;IACI;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,kCAAkC;QAClC,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,QAAQ;QACR,6BAA6B;QAC7B,2BAA2B;QAC3B,UAAU;QACV,yCAAyC;IAC7C;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;QACrB,aAAa;QACb,4BAA4B;IAChC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,cAAc;QACd,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;IACb;;IAEA,qBAAqB;IACrB,qBAAqB;IACrB,IAAI;IACJ;QACI,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,OAAO;QACP,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,OAAO;QACP,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA,+HAA+H;IAC/H;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,gBAAgB;QAChB,eAAe;QACf,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,cAAc;QACd,qBAAqB;QACrB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,yBAAyB;QACzB,2BAA2B;QAC3B,wBAAwB;QACxB,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,4BAA4B;QAC5B,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,yBAAyB;QACzB,0BAA0B;QAC1B,4BAA4B;QAC5B,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,qBAAqB;QACrB,sBAAsB;QACtB,gBAAgB;QAChB,0BAA0B;QAC1B,4BAA4B;QAC5B,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,8BAA8B;QAC9B,6BAA6B;QAC7B,WAAW;QACX,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;QACrB,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,4BAA4B;QAC5B,8BAA8B;IAClC;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA,6BAA6B;IAC7B;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,eAAe;QACf,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA,iBAAiB;AACjB;IACI,uBAAuB;AAC3B;;AAEA;IACI,+CAA+C;IAC/C,6DAA4D;IAC5D,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,6BAA6B;;AAEjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,kBAAkB;IAClB,sBAAsB;;IAEtB,cAAc;IACd,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;;IAGZ,qBAAqB;;IAErB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;;;IAII,oCAAoC;IACpC,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;;;IAGZ,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;IACd,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,qCAAqC;IACrC,0CAA0C;IAC1C,cAAc;IACd,+BAA+B;IAC/B,oCAAoC;IACpC,QAAQ;AACZ;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;;IAGrC,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;;IAEf,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,4BAA4B;;AAEhC;;AAEA;IACI,WAAW;IACX,4BAA4B;AAChC;;;AAGA;IACI,oBAAoB;AACxB;;AAEA,0BAA0B;AAC1B;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,qBAAqB;;IAErB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,sBAAsB;IACtB,oBAAoB;;AAExB;;AAEA;;IAEI,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;;IAErB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;;IAErC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;;IAEzB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;;IAGjB,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,4BAA4B;AAChC;;;AAGA,oBAAoB;AACpB;IACI;QACI,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;QACb,4BAA4B;QAC5B,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,iBAAiB;;IAErB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IAGI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA,+BAA+B;AAC/B;IACI,uBAAuB;IACvB,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;;;EAGA;MACI,aAAa;EACjB;;IAEE;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;AAEJ;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":["::-webkit-scrollbar {\n    width: 5px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #888;\n}\n\n\n.grecaptcha-badge {\n    visibility: hidden;\n}\n\n.price-three-dots-loading {\n    justify-content: end;\n}\n\n.CookieConsent > div {\n    flex: 1 0 0 !important;\n}\n\n.foreman {\n    padding-right: 50px !important;\n}\n\n.arrow_top_bottom {\n    position: fixed;\n    z-index: 99;\n    cursor: pointer;\n    bottom: 100px;\n    right: 25px;\n    background: #592C82;\n    color: #FFF;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25)\n}\n\n/* Button Declare */\n.primary_button_drillcut {\n    background: #FFFFFF !important;\n    border-radius: 5px;\n    font-weight: 700;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    font-family: acumin-pro, sans-serif !important;\n    color: #1A1A1A;\n    padding: 5px;\n    transition: all .5s ease;\n}\n\n.primary_button_drillcut:hover {\n    background: #592C82 !important;\n    color: #fff;\n}\n\n.secondary_button_drillcut {\n    font-weight: 700;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    background: #592C82 !important;\n    border-radius: 5px;\n    font-family: acumin-pro, sans-serif !important;\n    color: #FFF;\n    padding: 5px;\n    transition: all .5s ease;\n    border: 1px solid #592C82 !important;\n}\n\n.secondary_button_drillcut:hover {\n    background-color: #FFF !important;\n    color: #1A1A1A;\n    border: 1px solid #1A1A1A !important;\n}\n\n.orange_button_drillcut {\n    background: #EC7700 !important;\n    border-radius: 5px !important;\n    text-align: center;\n    font-weight: 700;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    color: #FFF;\n    padding: 5px;\n    border: 1px solid #EC7700 !important;\n}\n\n.product-input-search {\n    background-color: #fff !important;\n    border: 1px solid #444 !important;\n    border-radius: none !important;\n}\n\n.table-small-padding {\n    padding-left: 1em !important;\n    padding-right: 1em !important;\n}\n\n.orange_button_drillcut:hover {\n    background-color: #FFF !important;\n    color: #1A1A1A;\n    border: 1px solid #1A1A1A !important;\n}\n\n.transparent_button_drillcut {\n    background: transparent;\n    border-radius: 5px;\n    text-align: center;\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 24px;\n    color: #FFF;\n    padding: 5px;\n}\n\n.transparent_button_drillcut:hover, .transparent_button_drillcut[data-hover] {\n    background: #EC7700 !important;\n    border-color: transparent !important;\n}\n\n.orange_background_drillcut {\n    background: #EC7700 !important;\n}\n\n.lightgray_background_drillcut {\n    background: #F2F2F2;\n}\n\n/* Chakra css Update */\n.chakra-text {\n    width: 100%;\n    display: block;\n}\n\n.text_align_center {\n    text-align: center;\n}\n\n.chakra-heading {\n    font-family: acumin-pro, sans-serif !important;\n}\n\n.text_color_b_shade {\n    color: #1A1A1A;\n}\n\n.policies-content {\n    width: 80%;\n    margin: 30px auto;\n    text-align: initial;\n    max-width: 1450px !important;\n}\n\n.policies-content p {\n    margin: 15px 0;\n}\n\n/* Main container */\n\n.main_container.menuByCollections {\n    padding: 0 40px;\n    margin: 0 !important;\n    max-width: 1600px !important;\n}\n\n.overlaybody {\n    display: block;\n    position: absolute;\n    top: 46px;\n    overflow: hidden;\n    left: 0;\n    right: 0;\n    height: 100vh;\n    background: rgba(0, 0, 0, .5);\n    z-index: 1;\n}\n\n.drill_cut_tv_popup_heading {\n    text-align: center;\n    letter-spacing: 0.18px;\n    font-weight: 700;\n    font-size: 24px !important;\n    line-height: 24px !IMPORTANT;\n    margin-bottom: 10px !important;\n}\n\n.drill_cut_tv_popup_content {\n    font-size: 20px !IMPORTANT;\n    text-align: center;\n    margin-bottom: 15px !important;\n    letter-spacing: 0.18px;\n    line-height: 20px !IMPORTANT;\n}\n\n.main_container {\n    max-width: 1450px !important;\n    margin: auto;\n    width: 100%;\n    margin: auto;\n    position: relative;\n}\n\n.mini_1250_container {\n    max-width: 1250px !important;\n    margin: auto;\n}\n\n.mini_1100_container {\n    max-width: 1100px !important;\n    margin: auto;\n}\n\n.half_mini_width_drillcut {\n    width: 33.33%;\n}\n\n.flipping-book {\n    width: 100%;\n    margin: 50px auto;\n    max-width: 1450px;\n    height: 1000px;\n}\n\n.box_section_mt {\n    width: 100%;\n    max-width: 100%;\n}\n\n.width_40DrillCut {\n    width: 40%;\n    max-width: 100%;\n}\n\n.width_60DrillCut {\n    width: 60%;\n    max-width: 100%;\n}\n\n.width_50DrillCut {\n    width: 50%;\n    max-width: 100%;\n}\n\n.width_25DrillCut {\n    width: 25%;\n    max-width: 100%;\n}\n\n.width_75DrillCut {\n    width: 75%;\n    max-width: 100%;\n}\n\n/*.box_width_70 {*/\n/*    width: 70%;*/\n/*    max-width: 100%;*/\n/*}*/\n\n.Full_width_blockDrillcut {\n    width: 100%;\n    max-width: 100%;\n}\n\n.drillcut_purple {\n    color: #592C82;\n}\n\n/* Homeage announcmentbar */\n.announment_bar_homepage_mt {\n    padding: 13px;\n    color: #FFF;\n    text-transform: uppercase;\n}\n\n/* Home page first section css */\n.homepage_announcment_heading_text_mt {\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-weight: 500 !important;\n    font-size: 14px !important;\n    line-height: 17px !important;\n    font-family: acumin-pro, sans-serif !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\nspan.homepage_announcment_heading_logo_mt {\n    margin-right: 12px;\n}\n\n.main_slider_home_heading_mt {\n    font-weight: 400 !important;\n    font-size: 24px !important;\n    line-height: 29px !important;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.18px;\n    font-family: acumin-pro, sans-serif !important;\n}\n\n.slider_image_mt {\n    width: 100%;\n    background-size: cover;\n    /*height: 582px;*/\n}\n\n.main_slider_home_button {\n    border: 1px solid #FFF;\n    background: transparent !important;\n    width: 239px !important;\n    height: 48px !important;\n    font-style: normal;\n    font-weight: 600 !important;\n    font-size: 20px !important;\n    line-height: 56px !important;\n    font-family: acumin-pro, sans-serif !important;\n}\n\n.slider_components_mt {\n    display: flex !important;\n}\n\n.home_page_main_slider_mt {\n    position: relative;\n}\n\n.home_page_main_slider_mt .slick-dots {\n    top: 70%;\n    bottom: unset !important;\n    min-width: 200px;\n    padding-left: 160px;\n    text-align: left;\n}\n\n.home_page_main_slider_mt .slick-dots li {\n    margin: 0 0.25rem;\n}\n\n.home_page_main_slider_mt .slick-dots button {\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    padding: 0;\n    border: none;\n    border-radius: 100%;\n    background-color: #F2F2F2;\n    text-indent: -9999px;\n}\n\n.home_page_main_slider_mt li.slick-active button {\n    background-color: #EC7700;\n}\n\n.home_page_main_slider_mt .slick-arrow {\n    display: none !important;\n}\n\n.slick_slider_custom_arrows {\n    max-width: 537px;\n    justify-content: space-around;\n    height: 30px;\n    position: absolute;\n    top: 70%;\n    left: 0;\n    right: 0;\n}\n\n.slick_slider_custom_arrow svg {\n    fill: #FFF;\n    width: 25px;\n    height: 25px;\n}\n\n.productpricearticlepage {\n    letter-spacing: 0.18px;\n    text-decoration-line: underline;\n    color: #1A1A1A;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    text-align: left;\n}\n\n.slick_slider_custom_arrow {\n    position: absolute;\n    margin-top: 6px;\n    z-index: 1;\n}\n\n.slick_right_arrow {\n    left: 47%;\n}\n\n.slick_left_arrow {\n    left: 23%;\n}\n\n.cart_mobile_view {\n    margin-bottom: 15px;\n}\n\n/*  Drill cut second section */\n\n.box_design {\n    height: 244px;\n    margin: 0 8px;\n    background-size: cover;\n    position: relative;\n}\n\n.box_homepage_designs {\n    width: 100%;\n    height: 100%;\n    color: #FFF;\n    position: relative;\n}\n\n.blog_design_mt img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n#player {\n    max-width: 100%;\n    width: 100%;\n}\n\n.Image_container {\n    width: 100%;\n    height: 260px;\n}\n\n.search_Image_container {\n    width: 100%;\n    height: 180px;\n    position: relative;\n}\n\n.box_homepage_designs_content {\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    position: absolute;\n    left: 0;\n    padding-left: 20px;\n    text-align: left;\n    width: 100%;\n    bottom: 15%;\n}\n\n.box_homepage_designs_image_div {\n    position: absolute;\n    right: 0;\n}\n\n.box_homepage_designs_heading {\n    letter-spacing: 0.15px;\n    font-size: 35px !important;\n    line-height: 24px !important;\n    font-family: acumin-pro, sans-serif !important;\n    width: 100%;\n    text-align: left !important;\n    margin-bottom: 8px;\n}\n\n.box_homepage_designs_heading_first_w {\n    font-weight: 700;\n}\n\n.box_homepage_designs_heading_second_w {\n    font-weight: 300;\n}\n\n.box_homepage_designs_mini_heading {\n    letter-spacing: 0.15px;\n    font-weight: 500 !important;\n    font-size: 20px !important;\n    line-height: 24px !important;\n    margin-top: 5px;\n}\n\n.box_homepage_designs_button_box {\n    display: block;\n    width: 100%;\n}\n\n.box_homepage_designs_button {\n    display: block;\n    width: 130px;\n    margin-top: 25px;\n    text-align: center;\n}\n\n/* Slider Logo Section */\n.mini_container_mt {\n    max-width: 1250px !important;\n}\n\n.Logo_icons_full_width {\n    width: 100%;\n    max-width: 100%;\n    padding: 20px 0;\n}\n\n.logo_icons_logo_mt {\n    width: 216px;\n    display: grid !important;\n    height: 116px;\n    justify-content: center;\n    align-items: center;\n}\n\n.logo_slider_home_mt .slick-arrow {\n    width: 54px;\n    height: 54px;\n    z-index: 99;\n}\n\n/* Text with logo section css */\n.Background_color_schema_div {\n    width: 100%;\n    max-width: 100%;\n    background: #F2F2F2;\n    padding: 55px 25px 55px;\n}\n\n.icons_with_text_heading_home_mt {\n    max-width: 1000px !important;\n    margin: auto;\n    margin-bottom: 35px;\n}\n\n.logo_text_block_contain {\n    justify-content: center;\n}\n\n.logo_text_block_contain_heading {\n    color: #1A1A1A;\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    text-align: left;\n    width: 155px;\n}\n\n.text_main_home_mt {\n    max-width: 1100px !important;\n    margin: auto;\n}\n\n.text_main_home_mt_contain {\n    letter-spacing: 0.5px;\n    color: #000000;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 45px;\n}\n\n.text_main_home_mt_button_mt {\n    width: 250px;\n    display: block;\n    margin: auto;\n}\n\n/* Banner Image Section */\n.background_image_banner_image {\n    height: 400px;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.background_image_mt {\n    position: relative;\n}\n\n.background_image_mt_container {\n    max-width: 1200px !important;\n    margin: auto;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n}\n\n.background_image_mt_content_main {\n    height: 100%;\n    color: #FFF;\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    padding-left: 120px;\n}\n\n.background_image_mt_content_main_heading {\n    letter-spacing: -0.5px;\n    font-weight: 700 !important;\n    font-size: 54px !important;\n    line-height: 54px !important;\n    font-family: acumin-pro, sans-serif !important;\n    margin-bottom: 10px;\n}\n\nspan.background_image_mt_content_mini_heading {\n    font-weight: 300 !important;\n}\n\n.background_image_mt_content_main_text {\n    letter-spacing: 0.15px;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 24px;\n    text-align: left;\n    margin-bottom: 20px;\n    max-width: 390px;\n}\n\n.banner_button_mt {\n    width: 114px;\n}\n\n/* Latest Product css */\n.latest_product_heading {\n    color: #4D4D4D;\n    letter-spacing: 0.18px;\n    font-weight: 700 !important;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    margin-bottom: 35px;\n    font-family: acumin-pro, sans-serif !important;\n}\n\n\n.backgorund_latest_prod_mt {\n    background-color: #F4F4F4;\n}\n\n.latest_product_div_mt {\n    height: 260px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);\n    margin: 0 12px;\n}\n\n.backgorund_latest_prod_image {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n.box_view_design_mt {\n    justify-content: center;\n}\n\n\n.latest_product_contain {\n    margin-bottom: 20px;\n    justify-content: center;\n}\n\n.latest_product_div_contain {\n    padding: 25px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\np.latest_product_div_contain_icon {\n    margin-bottom: 10px;\n}\n\np.chakra-text.latest_product_div_contain_heading {\n    color: #1A1A1A;\n    letter-spacing: 0.18px;\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 24px;\n    margin-bottom: 5px;\n}\n\n.latest_product_div_contain_button {\n    width: 155px;\n    display: block;\n    margin-top: 25px;\n}\n\np.latest_product_div_contain_price {\n    color: rgba(26, 26, 26, 0.5);\n    letter-spacing: 0.18px;\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 24px;\n}\n\n/* Blog section css */\n.blog_design_mt {\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n    background: #FFF;\n}\n\n.blog_contain_mt {\n    padding: 30px 25px !important;\n    text-align: left;\n    min-height: 110px;\n}\n\n.blog_heading_mt {\n    color: #592C82;\n    font-size: 20px !important;\n    line-height: 22px !important;\n    letter-spacing: 0.1px;\n    text-transform: capitalize;\n    display: block;\n    font-weight: 600;\n}\n\n.blog_mini_heading_mt {\n    color: #592C82;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    margin-top: 3px;\n    font-weight: 600;\n}\n\n.blog_content_mt {\n    font-size: 14px !important;\n    line-height: 20px !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    line-clamp: 3;\n    -webkit-box-orient: vertical;\n}\n\n.blog_design_mt {\n    margin: 0 8px 20px;\n}\n\n.blog_search_page_image {\n    height: 180px;\n}\n\n.imageblogssearchpage {\n    width: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    height: 100%;\n}\n\n.blog_design_mt img {\n    width: 100%;\n}\n\n.blog_contain_searchpage {\n    padding: 20px !important;\n    text-align: left;\n}\n\n.blog_section_drillcut {\n    margin-bottom: 20px;\n}\n\n.blog_section_home_button_div {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.blog_section_home_button {\n    width: 250px;\n    display: block;\n    text-align: center;\n    margin: auto;\n}\n\n.blog_design_mt_image {\n    position: relative;\n    width: 100%;\n}\n\n.drillcut_tv_play_icon {\n    position: absolute !important;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 100% !important;\n    height: 100% !important;\n    background: transparent !important;\n}\n\n.drillcut_tv_play_icon svg {\n    fill: #FFF;\n}\n\n.drillcut_tv_play_icon svg {\n    fill: #FFF;\n    width: 65px;\n    height: 65px;\n}\n\n.slick_arrows_custom_logo {\n    position: absolute;\n    top: 35%;\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n    width: 54px;\n    height: 54px;\n    border-radius: 100%;\n    z-index: 99;\n    background: #FFF;\n}\n\n.slick_arrows_custom_logo_next {\n    right: 18px;\n}\n\n.slick_arrows_custom_logo_previous {\n    left: 18px;\n}\n\n.slick_arrows_custom_logo svg {\n    width: 20px;\n    margin: auto;\n    height: 20px;\n}\n\n/* Model css */\n.drill_cut_tv_popup {\n    max-width: 70% !important;\n    background: #F2F2F2 !important;\n    border-radius: 0 !important;\n    position: relative;\n}\n\n.drill_cut_tv_popup_hover {\n    background: rgba(0, 0, 0, 0.5) !important;\n}\n\n.drill_cut_tv_popup_body {\n    padding: 15px 0 0 0 !important;\n}\n\n.drillcuttv_popup_close_btn {\n    position: absolute !important;\n    right: -15px !important;\n    top: -15px !important;\n    width: 45px !important;\n    background: rgba(242, 242, 242, 1);\n    border-radius: 100% !important;\n    height: 45px !important;\n}\n\n.drillcuttv_popup_close_btn:hover, .drillcuttv_popup_close_btn[data-hover] {\n    background: rgba(242, 242, 242, 1) !important;\n}\n\n.drillcuttv_popup_close_btn:focus, .drillcuttv_popup_close_btn[data-focus] {\n    box-shadow: none !important;\n}\n\n.menu_drawer_overlay {\n    transform: translateX(0) translateY(70px) translateZ(0px) !important;\n}\n\n.menu_drawer_overlay {\n    transform: translateX(0) translateY(70px) translateZ(0px) !important;\n    background: rgba(0, 0, 0, 0.5) !important;\n}\n\n.chiled_header {\n    justify-content: center;\n}\n\n.drawermenu_item_mt span {\n    height: 17px;\n}\n\n.instagram_section_images img {\n    width: 100%;\n}\n\n.drillcutreusultcount {\n    padding: 50px 0;\n    letter-spacing: -0.5px;\n    font-weight: 700;\n    font-size: 54px;\n    line-height: 54px;\n    color: #FFF;\n    text-align: left;\n}\n\n/* ========================================== About Us page Drillcut ============================================ */\n\n.pages_AnnouncmentBar {\n    background: #592C82;\n    width: 100%;\n    text-align: left;\n    color: #FFF;\n}\n\n.about_announcment_container {\n    padding: 70px 15px;\n    max-width: 1450px;\n    margin: auto;\n}\n\n.pages_announment_bar_sub_heading {\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 17px;\n}\n\n.pages_announment_bar_heading {\n    letter-spacing: -0.5px;\n    font-weight: 700 !important;\n    font-size: 54px !important;\n    line-height: 54px !important;\n    color: #FFF;\n}\n\n.slider_box {\n    color: #FFF;\n}\n\n.about_us_content_mt {\n    max-width: 860px;\n    margin: auto;\n    margin-top: 50px;\n    margin-bottom: 50px;\n    text-align: left;\n}\n\n.video_about_mt {\n    max-width: 650px;\n    margin: auto;\n    margin-bottom: 60px;\n    position: relative;\n}\n\n.about_us_page_video_mt {\n    /*position: absolute;*/\n    /*top: 0;*/\n    /*right: 0;*/\n    /*left: 0;*/\n    /*bottom: 0;*/\n    justify-content: center;\n    align-items: center;\n    background: rgba(242, 242, 242, 0.5);\n}\n\n.about_us_page_video_button {\n    background: transparent !important;\n}\n\n.about_us_page_video_button svg {\n    width: 50px;\n    height: 50px;\n    fill: #FFF;\n}\n\n.about_us_brands_heading {\n    font-size: 24px !important;\n    line-height: 24px !important;\n    color: #1A1A1A;\n    letter-spacing: 0.18px;\n    margin-bottom: 10px;\n}\n\n.about_us_page_video_button:hover, .about_us_page_video_button[data-hover] {\n    background: transparent !important;\n}\n\n.about_us_page_video_button:focus, .about_us_page_video_button[data-focus] {\n    box-shadow: none !important;\n}\n\n.heading_image_withtext_about {\n    font-size: 24px !important;\n    letter-spacing: 0.18px;\n    color: #000;\n    line-height: 24px !important;\n    font-weight: 700 !important;\n    margin-bottom: 15px;\n}\n\n.content_image_withtext_about {\n    letter-spacing: 0.5px;\n    font-weight: 300 !important;\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.button_mt_about {\n    margin: 25px 0 !important;\n}\n\n.about_main {\n    padding: 100px 0 60px !important;\n}\n\n.about_slider_bg_image_mt {\n    background-size: cover;\n    min-height: 600px;\n    background-position: center center;\n    position: relative;\n}\n\n.about_page_slider_container_mt {\n    max-width: 1200px !important;\n    margin: auto;\n    position: absolute;\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.about_page_slider_container_contentmt {\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n}\n\n.about_page_slider_container_mt_heading {\n    letter-spacing: 0.18px;\n    font-weight: 700;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.about_us_page_slider {\n    width: 700px !important;\n}\n\n.about_us_page_sliderContent {\n    font-weight: 700;\n    font-size: 34px;\n    line-height: 36px;\n}\n\n.about_us_page_sliderheading {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 38px;\n    margin-top: 15px;\n    margin-bottom: 25px;\n}\n\n.aboutuspage_sliderButton {\n    padding: 6px 25px !important;\n}\n\n.aboutpage_sliderBox {\n    max-width: 600px;\n    margin: auto;\n    color: #FFF;\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {\n    left: 16%;\n}\n\n.about_page_slider_container_contentmt .slick_arrows_custom_logo_next {\n    right: 15%\n}\n\n.about_page_slider_container_contentmt .slick_arrows_custom_logo {\n    top: 40%;\n}\n\n.about_page_slider_container_contentmt .slick-dots {\n    bottom: -20%;\n}\n\n.aboutpage_logoSectionHeading {\n    font-size: 24px !important;\n    letter-spacing: 0.18px;\n    line-height: 24px;\n    margin-bottom: 40px;\n}\n\n.aboutpage_containerLogo {\n    max-width: 1200px !important;\n    margin: auto;\n}\n\n.logo_image_button_aboutuspage {\n    width: 210px !important;\n    height: 210px !important;\n    background: transparent !important;\n    padding: 0 !important;\n}\n\n.logo_image_button_aboutuspage:focus, .logo_image_button_aboutuspage[data-focus] {\n    box-shadow: none !important;\n}\n\n.logo_image_title_aboutuspage {\n    font-size: 20px !important;\n    letter-spacing: 0.15px;\n    line-height: 20px !important;\n    margin-top: 20px;\n}\n\n.logo_image_subtitle_aboutuspage {\n    font-size: 14px !important;\n    line-height: 17px !important;\n    margin-top: 10px !important;\n    text-transform: uppercase;\n    margin-bottom: 20px;\n}\n\n.about_page_popupBody {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.about_page_popupBodyTitle {\n    font-size: 34px !IMPORTANT;\n    line-height: 36px !important;\n    margin-top: 20px;\n}\n\n.about_page_popupBodySubtitle {\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-size: 14px !important;\n    line-height: 17px !IMPORTANT;\n    margin-top: 15px;\n    margin-bottom: 35px;\n}\n\n.about_page_popupBodyContent {\n    max-width: 595px;\n    letter-spacing: 0.25px;\n    font-size: 14px !important;\n    line-height: 20px !important;\n    font-weight: 300;\n}\n\n.about_page_popupBodysocialLink {\n    justify-content: center;\n    align-items: center;\n    margin: 50px 0;\n}\n\nspan.about_page_popupBodysocialLinkIcon {\n    margin-right: 15px;\n}\n\n.about_page_popupBodyLink {\n    color: #EC7700;\n    font-size: 15px;\n}\n\n.about_page_popup {\n    margin-bottom: 0 !important;\n}\n\n.eror_class {\n    border-color: red !important\n}\n\n/* ================================================== Substainibilty page css =============================================== */\n.substainibilitypage_container {\n    max-width: 960px !IMPORTANT;\n    margin: 70px auto 70px;\n\n    text-align: left;\n}\n\n.substainablity_content {\n    letter-spacing: 0.5px;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: left;\n}\n\n.substainabilitypage_content_heading {\n    font-size: 20px !important;\n    text-align: left;\n    margin-bottom: 5px;\n    line-height: 20px !important;\n}\n\n.substainabilitypage_content_Subheading {\n    font-size: 16px !important;\n    line-height: 16px !important;\n}\n\n.list_Substainibility_page {\n    padding-left: 15px;\n    margin-top: 5px;\n}\n\n.list_Substainibility_page li {\n    font-size: 16px;\n    font-weight: 300 !important;\n}\n\n/* ================================================== Contact Us page css start =============================================== */\n.contactus_page_container {\n    max-width: 1000px !important;\n    margin: auto;\n}\n\n.contactUspage_block_Details_heading {\n    letter-spacing: 0.18px;\n    font-size: 24px !important;\n    line-height: 24px !important;\n}\n\n.contactUspage_block {\n    margin-top: 50px;\n    padding-bottom: 10px;\n}\n\n.contactUspage_block_Details {\n    margin-top: 65px;\n    text-align: left;\n}\n\n.contactUspage_block_Details_link {\n    letter-spacing: 0.4px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n}\n\n.contactUspage_block_Details_emails {\n    margin-bottom: 30px;\n}\n\n.chakra-text.contactUspage_block_DetailsContent {\n    margin-top: 30px;\n    margin-bottom: 5px;\n}\n\n.contactUspage_block_Details_emailsHeading {\n    letter-spacing: 0.5px;\n    font-weight: 700;\n    font-size: 16px !important;\n    line-height: 24px !important;\n}\n\n.contactUspage_block_Details_emailslink {\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n}\n\n.contactUspage_block_Details_socialIcons {\n    display: flex;\n    margin-left: 0 !important;\n    margin-top: 10px;\n}\n\n.contactUspage_block_Details_socialIcons li {\n    list-style-type: none;\n    margin: 0;\n    margin-right: 10px;\n}\n\n.contactUspage_block_Details_socialIconsicon svg {\n    width: 24px;\n    height: 24px;\n}\n\n.grey_background_drillcut {\n    background: #F7F7F7;\n}\n\n.yd_signup_background {\n    background: #F2F2F2;\n}\n\n.login_page_block label.sameaddr-checkbox {\n    float: right;\n    margin-top: 24px;\n    flex-direction: row-reverse;\n}\n\n.sameaddr-checkbox .chakra-checkbox__label {\n    font-size: 12px;\n    margin-right: 10px;\n}\n\n.contactUspage_block_Form_block {\n    padding: 70px;\n}\n\n.label_name_Contactform {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.15px;\n    text-transform: uppercase;\n}\n\n.contactUspage_block_Form_block {\n    padding: 45px 45px 55px;\n}\n\n.form_submit_Button {\n    padding: 4px 45px;\n    cursor: pointer;\n}\n\n.maps_location_heading {\n    letter-spacing: 0.18px;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    margin-bottom: 25px;\n}\n\n.map_section_block {\n    margin-top: 40px;\n    margin-bottom: 100px;\n}\n\n.bottom_border_contactUspage {\n    border-bottom: 1px solid #C4C4C4;\n}\n\n.map_content_background {\n    background: #F2F2F2;\n    padding: 20px 25px;\n    text-align: left;\n}\n\n.contactUspage_block_Details_heading.drillcut_purple {\n    letter-spacing: 0.18px;\n    font-size: 24px !important;\n    line-height: 24px !important;\n}\n\n.map_adreesMobile_number_address {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n}\n\n.map_adreesMobile_number_number {\n    letter-spacing: 0.5px;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: right;\n}\n\n.schdule_timemaps {\n    letter-spacing: 0.5px;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n    margin-top: 15px;\n}\n\n/* ================================================== Contact Us page css end =============================================== */\n.map_heading_mt {\n    font-size: 24px !important;\n    line-height: 24px !important;\n    letter-spacing: 0.18px;\n    margin-bottom: 5px;\n}\n\n/* ================================================== Drillcut Tv page css =============================================== */\n.drillcuttv_page_header_buttons {\n    background: #F2F2F2;\n    padding: 32px 60px;\n    text-align: left;\n}\n\n.drillcuttv_page_header_buttons_btn {\n    margin-right: 15px;\n    padding: 10px 25px;\n    text-transform: capitalize;\n    font-size: 15px !important;\n    line-height: 24px !important;\n    margin-bottom: 15px;\n}\n\n.extra_tags_button .drillcuttv_page_header_buttons_btn {\n    color: #1A1A1A;\n}\n\n.drillcut_tv_page_container {\n    max-width: 1450px !important;\n    margin: auto;\n}\n\n.pagination_block_mt {\n    justify-content: space-between;\n    padding: 20px 8px;\n    align-items: center;\n}\n\n.pagination_links_ul {\n    padding: 0 15px;\n}\n\n.current_pages_mt {\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n}\n\n.paginate_items_list {\n    display: flex;\n}\n\n.paginate_items_list .previous, .paginate_items_list .next {\n    background: #4D4D4D !important;\n    border-radius: 5px;\n    width: 32px !important;\n    height: 32px !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n}\n\n.paginate_items_list .previous a, .paginate_items_list .next a {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n.pagination_links_ul button {\n    background: transparent !important;\n}\n\n.paginate_items_list svg {\n    fill: #FFF;\n    width: 16px;\n    height: 16px;\n}\n\n.paginate_items_list li {\n    list-style-type: none;\n    background: transparent !important;\n    font-size: 14px !important;\n    line-height: 17px !important;\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    width: 32px !important;\n    height: 32px !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.total_pages_tv_page {\n    text-transform: uppercase;\n    letter-spacing: 0.1px;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n}\n\n.page_container_change {\n    max-width: 1450px;\n}\n\n.drillcuttv_subfilters {\n    background: #F2F2F2;\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n}\n\n.drillcuttv_subfilters_button_mt {\n    background: #EC7700 !important;\n    border-radius: 0 !important;\n    letter-spacing: 0.18px;\n    color: #FFF;\n    font-size: 24px;\n    line-height: 24px;\n    padding: 26px 70px !important;\n}\n\n.drillcuttv_subfilters_checkboxes {\n    margin-left: 20px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n\n.drillcuttv_subfilters_checkbox {\n    align-items: center;\n    padding-right: 45px;\n    padding-bottom: 12px;\n    padding-top: 12px;\n}\n\n.drillcuttv_subfilters_checkbox_box {\n    width: 24px !IMPORTANT;\n    height: 24px !important;\n    border-radius: 50% !important;\n    background: #FFFFFF;\n    border: 1px solid #E2E2E2;\n    cursor: pointer;\n}\n\n.searchpagesubfilters {\n    margin-bottom: 25px;\n}\n\nselect#searchpage_sort {\n    width: 250px !important;\n    border-radius: 5px;\n    border: 1px solid #C4C4C4;\n}\n\n.searchsort_box {\n    margin-right: 25px;\n}\n\n.drillcuttv_subfilters_checkbox .chakra-checkbox__input {\n    width: 24px !important;\n    height: 24px !important;\n}\n\n.drillcuttv_subfilters_checkbox_label {\n    letter-spacing: 0.15px;\n    font-size: 16px;\n    line-height: 24px;\n    padding-left: 10px;\n    cursor: pointer;\n}\n\n/* ============================================ Blog page css ============================================  */\n.drop_downmenu_blogpage {\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;\n    background: #F2F2F2 !important;\n    border-radius: 0 !important;\n    min-width: 150px !important;\n    border-top: 5px solid #592C82 !important;\n}\n\n.drillcuttv_subfilters_button_mt:hover, .drillcuttv_subfilters_button_mt[data-hover] {\n    background: #EC7700 !important;\n}\n\n/* ============================================ Drillcut tv page  ============================================  */\n\n.flilters_buttondownloadpage {\n    width: 100%;\n    padding: 13px;\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n    padding-left: 40px;\n    text-align: left;\n    letter-spacing: 0.18px;\n    font-weight: 700;\n    font-size: 24px !IMPORTANT;\n    line-height: 24px !important;\n    color: #FFF;\n}\n\n.flilters_downloadpage {\n    text-align: left;\n    width: 100%;\n    display: block;\n    padding: 13px;\n    padding-left: 40px;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.15px;\n    border-bottom: 1px solid rgba(77, 77, 77, 0.2);\n}\n\n.download_subtags_box {\n    padding: 28px 0px;\n    /*padding-left: 55px;*/\n    flex-wrap: wrap;\n}\n\n.tableblogdownloadspage_mt tr:nth-of-type(odd) {\n    background: rgba(255, 255, 255, 0.5) !important;\n}\n\n.tableblogdownloadspage_mt tr:nth-of-type(odd) td, .tableblogdownloadspage_mt tr:nth-of-type(even) td {\n    background: transparent !important;\n}\n\n.tableblogdownloadspage_mt tr:nth-of-type(even) {\n    background: rgba(242, 242, 242, 0.5) !important;\n}\n\n.tableblogdownloadspage_mt tr td {\n    border: none !important;\n}\n\n.tableblogdownloadspage_mt tr {\n    padding: 0 15px;\n    display: block;\n    width: 100%;\n}\n\n.downloads_page_space {\n    padding: 0 25px;\n}\n\n.downloads_page_content_mt {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.downloads_page_content_td_mt {\n    align-items: center;\n}\n\n.downloads_page_content_td_mt_heading {\n    padding-left: 50px;\n    letter-spacing: 0.25px;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 21px;\n    text-transform: capitalize;\n}\n\n.download_svg {\n    display: flex;\n    align-items: center;\n}\n\n.download_button_mt {\n    padding: 6px 43px;\n    display: flex;\n}\n\n.download_svg svg {\n    display: inline;\n    width: 20px !important;\n    height: 20px !important;\n    margin-right: 15px;\n}\n\n.extra_tags_button {\n    background: transparent !important;\n    color: #1A1A1A;\n    font-weight: 700;\n    font-size: 15px !IMPORTANT;\n    line-height: 24px !important;\n}\n\n.extra_tags_button svg {\n    width: 25px !important;\n    height: 25px !important;\n    font-weight: 700;\n}\n\n.extra_tags_button:focus, .extra_tags_button[data-focus] {\n    box-shadow: none !important;\n}\n\n/* ============================================ Article page css ============================================ */\n.newsletter_block_articleDrillcut {\n    align-items: center;\n    background: #E9EAEB;\n    border-radius: 8px;\n    width: 520px;\n    margin-top: 15px;\n}\n\n.newsletter_block_articleDrillcutEmail input {\n    color: rgba(0, 0, 0, 0.5);\n    letter-spacing: 0.5px;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.newsletter_block_articleDrillcutButton {\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%) !important;\n    border-radius: 0px 8px 8px 0px !important;\n    background: #FFF !important;\n    text-transform: uppercase;\n    min-width: 100px !important;\n    letter-spacing: 1.25px;\n    font-weight: 700;\n    font-size: 14px !important;\n    line-height: 16px !important;\n    color: #1A1A1A;\n}\n\n.newsletter_block_articleDrillcutButton:hover {\n    background: #592C82 !important;\n    color: #fff;\n}\n\n.newsletter_block_articleDrillcutEmail input:focus, .newsletter_block_articleDrillcutEmail input[data-focus] {\n    box-shadow: none !important;\n    border-color: inherit !important;\n}\n\n.back_button {\n    padding: 4px 45px;\n    height: auto !important;\n    text-transform: uppercase;\n}\n\n.article_last_border {\n    background: #C4C4C4;\n    width: 100%;\n    height: 0.5px;\n    padding: 0;\n    margin-bottom: 50px;\n}\n\n.downloads_pagepagination {\n    padding: 15px 0 !important;\n}\n\n.social_iconsArticleContent {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.article_social_icons {\n    list-style-type: none !important;\n}\n\n.article_social_icons li {\n    float: left;\n    width: 40px;\n    height: 40px;\n    margin-left: 15px !important;\n}\n\n.social_iconsArticle {\n    width: 100% !important;\n    height: 100% !important;\n}\n\n.drillcutArticleProductsectionminiHeading {\n    color: #1A1A1A;\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px !important;\n    line-height: 17px !important;\n}\n\n.drillcutArticleProductsectionHeading {\n    color: #1A1A1A;\n    letter-spacing: 0.18px;\n    font-weight: 700;\n    font-size: 24px !important;\n    line-height: 24px !important;\n}\n\n.drillcutProductBlock {\n    margin: 50px 0;\n}\n\n.articleproducts_mt {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n}\n\n/*.articleproducts_mt_backgroundColor {*/\n/*    height: 190px;*/\n/*}*/\n\n.articleproducts_mt_backgroundColor img {\n    margin: auto;\n}\n\n.articleproducts_mt_ProductImage {\n    align-items: center;\n    height: 100%;\n}\n\n.ArticleProductTitle.drillcut_purple {\n    letter-spacing: 0.15px;\n    font-weight: 700 !important;\n    font-size: 20px !important;\n    line-height: 24px !important;\n    text-align: left;\n    text-transform: capitalize;\n}\n\n.articleproducts_mt_content {\n    padding: 15px;\n}\n\n.ArticleProductSku {\n    letter-spacing: 1.5px;\n    color: #4D4D4D;\n    font-weight: 500;\n    font-size: 10px !important;\n    line-height: 12px !important;\n    text-align: left;\n}\n\n.login_buttonArticleProduct {\n    text-align: right;\n    display: block;\n    width: 100%;\n    color: #1A1A1A;\n    text-decoration: underline;\n    letter-spacing: 0.18px;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    margin-bottom: 12px;\n}\n\n.ArticleProductButton {\n    width: 100%;\n    display: block;\n    padding: 7px;\n}\n\n.articlecontent_Description {\n    letter-spacing: 0.5px;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: justify;\n}\n\n.slider_gallery_images {\n    width: 99% !important;\n    max-width: 100%;\n    display: block;\n    height: 500px !important;\n    background: transparent !important;\n    padding: 0 !important;\n}\n\n.sliderImages {\n    margin: 0 20px;\n}\n\n.slider_gallery_images img {\n    max-width: 100%;\n    width: 100%;\n}\n\n.gallery_slider .slick-dots li button:before, .slidergalleryModalContentgallery_slider .slick-dots li button:before {\n    color: #F2F2F2 !important;\n}\n\n.gallery_slider .slick-dots li.slick-active button:before, .slidergalleryModalContentgallery_slider .slick-dots li.slick-active button:before {\n    color: #EC7700 !important;\n}\n\n.gallery_slider .slick-dots, .slidergalleryModalContentgallery_slider .slick-dots {\n    margin-top: 15px;\n    bottom: inherit !important;\n}\n\n.slider_gallery_images_image {\n    width: 100%;\n    max-width: 100%;\n}\n\n.slidergalleryModalContent {\n    max-width: 100% !important;\n    position: relative;\n}\n\n.modal_overlayGallerySlider {\n    background: #FFF !important;\n}\n\n.slickArrowArticleImageGallery {\n    position: absolute;\n    top: 50%;\n    width: 25px;\n    height: 25px;\n    transform: translate(0, -50%);\n    z-index: 9999;\n}\n\n.slickArrowArticleImageGallery_previous {\n    left: 10%;\n}\n\n.slickArrowArticleImageGallery_next {\n    right: 10%;\n}\n\n.slickArrowArticleImageGallery svg {\n    width: 100%;\n    height: 100%;\n    fill: #FFF;\n}\n\n.more_articles_heading {\n    letter-spacing: 0.18px;\n    font-weight: 700;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    color: #1A1A1A;\n    margin-bottom: 35px;\n    text-transform: capitalize;\n}\n\n.paginate_items_list li.pagination__link--disabled {\n    background: rgb(77 77 77 / 50%) !important;\n}\n\n.downloads_page_content_mt {\n    padding: 30px 10px !important;\n}\n\n.table_downloads {\n    margin-bottom: 35px;\n}\n\n.downloads_page_content_mt td {\n    padding: 0 !important;\n}\n\n/* ============================================ Search Page =============================================== */\n.search_page_main_filter {\n    background: #592C82;\n    width: 100%;\n    display: block;\n}\n\n.drllcutfilterLink {\n    color: rgba(255, 255, 255, 0.5);\n    letter-spacing: 0.15px;\n    font-weight: 700 !important;\n    font-size: 20px !important;\n    line-height: 24px !important;\n    background: transparent !important;\n}\n\n.drillcutFilters {\n    padding: 28px 0;\n}\n\n.drllcutfilterLink {\n    box-shadow: none !Important;\n}\n\n.searchpageFilterContainer {\n    max-width: 1260px !important;\n    margin: auto;\n}\n\n.search_page_main_filter {\n    border-top: 1px solid #FFF;\n}\n\n.drillcutFilters_boxShadow {\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n}\n\n.searchFilterbuttonDefault {\n    margin-top: 25px;\n}\n\n.searchsubfilterAccordinButton:focus, .searchsubfilterAccordinButton[data-focus] {\n    box-shadow: none !important;\n}\n\n.searchsubfilterAccordinButton:hover, .searchsubfilterAccordinButton[data-hover] {\n    background: transparent !important;\n}\n\n.accordianSubFilters {\n    background: #F2F2F2;\n    padding: 20px 30px;\n}\n\n.accordianItem {\n    border: none !important;\n}\n\n.mainAccordianHeading {\n    letter-spacing: 0.15px;\n    color: #000000;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    text-transform: capitalize;\n}\n\n.accordian_Content {\n    margin-top: 20px;\n}\n\n.searchProductsGrid {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n    margin-top: 10px;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.productImageBackground {\n    height: 200px;\n    background: #F2F2F2;\n    justify-content: center;\n    align-items: center;\n}\n\n.productImageBackgroundImage {\n    width: 200px;\n}\n\n.drillcutsearchMainResult {\n    padding: 10px 35px 35px 20px;\n}\n\n.productContent {\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n}\n\n.SeacrhpageproductTitle {\n    letter-spacing: 0.15px;\n    font-weight: 700;\n    font-size: 20px !important;\n    line-height: 24px !important;\n    text-align: left;\n    margin-bottom: 18px;\n    display: block;\n    text-transform: capitalize;\n}\n\n.viewproductsButtonSearchpage {\n    width: 100% !important;\n    display: block;\n    padding: 8px;\n}\n\n.SearchBlogGrid {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n}\n\n.gallerySliderCloseButton {\n    top: -17px !important;\n    z-index: 99;\n    background: #FFF !important;\n    border-radius: 50% !important;\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n    right: 0 !important;\n}\n\n/*  */\n.modalSearchButton {\n    display: block !important;\n    padding: 0 !important;\n    background-color: transparent !important;\n}\n\n.SearchModalOpenContent {\n    width: 100% !important;\n    display: block !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    border: none !important;\n    border-radius: 0 !important;\n}\n\n.aa-panel {\n    z-index: 9999 !important;\n}\n\n#search_mt {\n    display: none;\n}\n\n.create-dropdown > div:not(.no-width) {\n    width: 90%;\n\n}\n\n/* ============================================ Search Page view ============================================  */\n.searchBox_searchPage {\n    position: relative;\n}\n\n.searchBox_searchPage input.ais-SearchBox-input {\n    border: 1px solid rgba(0, 0, 0, 0.25) !important;\n    height: 40px;\n    border-right: 0;\n    border-radius: 8px;\n    padding: 10px 15px;\n    box-shadow: none;\n    font-size: 16px;\n    vertical-align: top;\n    width: 100%;\n    max-width: 430px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n/*button.ais-SearchBox-reset {*/\n/*    display: none;*/\n/*}*/\n\n.searchDatamt ul {\n    list-style-type: none !important;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 20px;\n}\n\n.searchDatamt ul li {\n    width: 100%;\n}\n\n.search_blog_design_mt {\n    margin: 0 !important;\n}\n\n.refinementcss ul {\n    list-style-type: none;\n    text-align: left;\n}\n\n.drillcut_tv_play_icon:focus, .drillcut_tv_play_icon[data-focus] {\n    box-shadow: none !important;\n}\n\n.DownloadSearchMt ul {\n    width: 100%;\n    list-style-type: none;\n}\n\n.searchpageDownloadsImageBox {\n    width: 80px;\n    height: 80px;\n}\n\n.searchpageDownloadsImageBox img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.DownloadSearchMt ul li:nth-of-type(even) {\n    background: rgba(242, 242, 242, 0.5) !important;\n}\n\n.DownloadSearchMt ul li:nth-of-type(odd) {\n    background: rgba(255, 255, 255, 0.5) !important;\n}\n\n.searchBox_searchPage form.ais-SearchBox-form {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\na.login_button_tab {\n    text-decoration: underline;\n    color: rgba(26, 26, 26, 0.5);\n    letter-spacing: 0.18px;\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 24px;\n}\n\n.searchBox_searchPage .ais-SearchBox-submit {\n    letter-spacing: 1.25px;\n    text-transform: uppercase;\n    color: #FFF;\n    font-family: acumin-pro, sans-serif;\n    font-weight: 700;\n    font-style: normal;\n    font-size: 14px !important;\n    line-height: 16px;\n    border: 1px solid;\n    border-color: #592C82;\n    background: #553C9A;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-items: center;\n    padding: 0 25px;\n    border-radius: 8px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.searchBox_searchPage .ais-SearchBox-input:focus-visible {\n    outline: none !important;\n}\n\n.drllcutfilterLink[aria-selected=\"true\"] {\n    color: #FFF !important;\n    border: none !important;\n}\n\n.drllcutfilterLink {\n    border: none !important;\n}\n\n.searchPage_pagination ul.ais-Pagination-list {\n    list-style-type: none;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.searchPage_pagination .ais-Pagination-item--firstPage {\n    display: none;\n}\n\n.searchPage_pagination .ais-Pagination-item--previousPage,\n.searchPage_pagination .ais-Pagination-item--nextPage {\n    background: #4D4D4D !important;\n    border-radius: 5px;\n    width: 32px !important;\n    height: 32px !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n}\n\n.searchPage_pagination .ais-Pagination-item--disabled {\n    background: rgb(77 77 77 / 50%) !important;\n}\n\n.searchPage_pagination .ais-Pagination-link {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    letter-spacing: 0.1px;\n    line-height: 17px;\n    font-weight: 700;\n}\n\n.searchPage_pagination .ais-Pagination-link svg {\n    fill: #FFF;\n    width: 16px;\n    height: 16px;\n}\n\n.searchPage_pagination {\n    padding: 20px 35px 0px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.searchPage_pagination_bottom {\n    padding: 0px 35px 20px 20px;\n}\n\n.paginate_count {\n    font-weight: bold;\n}\n\n.searchPage_pagination .chakra-select__wrapper {\n    width: 250px;\n}\n\n.searchPage_pagination .ais-Pagination {\n    margin-left: 40px;\n}\n\n.searchPage_pagination .ais-Pagination-item--page {\n    list-style-type: none;\n    background: transparent !important;\n    font-size: 14px !important;\n    line-height: 17px !important;\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    width: 32px !important;\n    height: 32px !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.searchPage_pagination .ais-Pagination-item--page.ais-Pagination-item--selected {\n    background: #EC7700 !important;\n    border-radius: 5px;\n    box-shadow: none !important;\n}\n\n.tab_data_search {\n    position: relative;\n}\n\n.tab_data_search[aria-expanded=\"true\"] .arrowactivetabsearch {\n    width: 0;\n    height: 0;\n    border-right: 9px solid transparent;\n    border-left: 9px solid transparent;\n    border-bottom: 9px solid #FEFEFE;\n    position: absolute;\n    top: -9px;\n}\n\ndiv#one[aria-expanded=\"true\"] .arrowactivetabsearch {\n    left: 18.5%;\n}\n\ndiv#two[aria-expanded=\"true\"] .arrowactivetabsearch {\n    left: 39%;\n}\n\ndiv#three[aria-expanded=\"true\"] .arrowactivetabsearch {\n    left: 59.5%;\n}\n\ndiv#four[aria-expanded=\"true\"] .arrowactivetabsearch {\n    left: 79.5%;\n}\n\n.ProductImageSearchPage {\n    width: 100%;\n    height: 100%;\n    aspect-ratio: 16 / 13;\n    min-height: 200px;\n    object-fit: cover;\n}\n\nimg.backgorund_latest_prod_mt_image {\n    width: 320px;\n    height: 100%;\n    object-fit: cover;\n}\n\n.ais-Pagination-list--noRefinement, .ais-Pagination--noRefinement {\n    display: none !important;\n}\n\ninput.ais-RefinementList-checkbox {\n    background: #FFFFFF;\n    border: 1px solid #E2E2E2;\n    border-radius: 4px;\n    width: 24px;\n    height: 24px;\n    margin-right: 15px;\n    cursor: pointer;\n}\n\nlabel.ais-RefinementList-label {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    cursor: pointer;\n}\n\nspan.ais-RefinementList-labelText {\n    letter-spacing: 0.15px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    text-transform: capitalize;\n}\n\nspan.ais-RefinementList-count:before {\n    display: inline;\n    content: \"(\";\n}\n\nspan.ais-RefinementList-count:after {\n    display: inline;\n    content: \")\";\n}\n\n.Sort_pagination {\n    display: flex;\n    align-items: center;\n}\n\nbody.scrolllock {\n    position: fixed;\n    width: 100%;\n    overflow-y: scroll;\n}\n\n.icons_with_text_button {\n    background: transparent !important;\n    align-items: center;\n    justify-content: center;\n    margin: 0 !IMPORTANT;\n}\n\n.icons_with_text_button a {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 15px;\n    font-weight: 400;\n}\n\n.header_icons_mt_new_Drillcut {\n    width: 35px !important;\n    height: 35px !important;\n}\n\n/* ============================================ Collections Page Css ======================================= */\n.CollectionsBrowse {\n    width: 100% !important;\n    border-radius: 0 !important;\n    letter-spacing: 0.18px;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    padding-left: 40px !important;\n    text-align: left !important;\n    justify-content: start !important;\n}\n\n.Collection_title_filter {\n    justify-content: space-between !important;\n    letter-spacing: 0.15px;\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    padding: 13px 25px !important;\n    padding-left: 40px !important;\n}\n\n.Collection_title_filter:hover, .Collection_title_filter[data-hover] {\n    background: inherit !important;\n}\n\n.Collection_title_filter:focus, .Collection_title_filter[data-focus] {\n    box-shadow: none !important;\n}\n\n.Subcollection_link_button {\n    display: block;\n    padding-left: 40px;\n    text-align: left;\n    letter-spacing: 0.5px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 34px;\n}\n\n.CollectionsData {\n    display: flex;\n}\n\n.collection_grid {\n    padding: 40px 35px 35px 20px;\n}\n\n.collectiongrid_item {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n}\n\n.collectionImage {\n    width: 100%;\n    height: 230px;\n}\n\n.collectionImage img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.collection_title_collectionPage {\n    font-size: 20px !important;\n    letter-spacing: 0.15px;\n    font-weight: 700 !important;\n    line-height: 24px !important;\n    padding: 15px;\n}\n\n.drillcuttvFiltersTvpage {\n    justify-content: start;\n    flex-wrap: wrap;\n}\n\n.drillcutSecondLineFilters {\n    margin-top: 15px;\n}\n\n.subcollectionButton {\n    border: none !important;\n}\n\n.mini_sub_title_data {\n    padding-top: 0 !important;\n}\n\n.subcollection_title_filter {\n    padding-right: 10px !important;\n    font-weight: 400 !important;\n}\n\n.CollectionsBrowse:hover {\n    background: #EC7700 !important;\n    color: #FFF !important;\n    border: none !important;\n}\n\n.SelectCategoryRow {\n    background: #F2F2F2;\n    display: flex;\n}\n\n.selectbox_Box_category {\n    text-transform: uppercase;\n    color: rgba(0, 0, 0, 0.5);\n    font-weight: 700;\n    padding: 0 19.5px !important;\n    padding-top: 19.5px !important;\n    font-size: 14px !important;\n    line-height: 17px !important;\n    letter-spacing: 0.1px;\n    text-align: left;\n}\n\n.selectbox_Box {\n    width: 20%;\n    padding-left: 40px;\n    padding-bottom: 19.5px;\n    border-right: 1px solid rgba(0, 0, 0, 0.2);\n}\n\n.selectbox_Box_select {\n    border: none !important;\n    letter-spacing: 0.15px;\n    font-weight: 700;\n    font-size: 20px !important;\n    line-height: 20px !important;\n    height: auto !important;\n    cursor: pointer;\n}\n\n.SearchNormalBox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.search_button_home {\n    letter-spacing: 1.25px;\n    text-transform: uppercase;\n    color: #FFF;\n    font-family: acumin-pro, sans-serif;\n    font-weight: 700;\n    font-style: normal;\n    font-size: 14px !important;\n    line-height: 16px;\n    border: 1px solid;\n    border-color: #592C82;\n    background: #553C9A;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-items: center;\n    padding: 0 25px;\n    border-radius: 8px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.selectbox_Box_select:focus, .selectbox_Box_select[data-focus] {\n    box-shadow: none !important;\n}\n\n.CollectionsBrowse:focus, .CollectionsBrowse[data-focus] {\n    box-shadow: none !important;\n}\n\n/* Cart page */\n.quantity_buttons_cart_page {\n    background: #F2F2F2;\n    border-radius: 5px;\n    width: 160px;\n    margin: 0;\n}\n\n.buttons_cartPage_inc_dec {\n    padding: 13px;\n    width: 45px;\n}\n\n.decrement_cartButton {\n    border-right: 1px solid rgba(196, 196, 196, 0.5);\n}\n\n.increment_cartButton {\n    border-left: 1px solid rgba(196, 196, 196, 0.5);\n}\n\n.cart_page_quantity_input {\n    width: 70px !important;\n    text-align: center;\n    letter-spacing: 0.18px;\n    color: #1A1A1A;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    border: none !important;\n}\n\n.checkout_button_css_mt {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.articleproducts_mt_ProductImage img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.react_player_full_width {\n    width: 100% !important;\n    max-width: 100% !important;\n    display: block;\n}\n\n.react_player_mt {\n    width: 100% !important;\n    max-width: 100% !important;\n    display: block;\n    height: 78vh !important;\n}\n\n.aa-Panel {\n    z-index: 150;\n}\n\n.aa-Form {\n    width: 100%;\n}\n\n.drill-cut-link-active li {\n    border-left: 8px solid #F58220 !important;\n    color: #F58220 !important;\n}\n\n.external_html ul {\n    list-style-type: initial;\n    -webkit-margin-start: 1em;\n    margin-inline-start: 1em;\n}\n\n.external_html h2 {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 24px;\n    text-align: left;\n    letter-spacing: 0.18px;\n    color: #1A1A1A;\n    padding: 25px 0px 20px;\n}\n\n.external_html h3 {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n    text-align: left;\n    letter-spacing: 0.18px;\n    color: #1A1A1A;\n    padding: 25px 0px 20px;\n}\n\n.smcx-embed {\n    margin: auto;\n}\n\n/* ============================================ Responsive view ============================================  */\n\n@media (max-width: 1500px) {\n    .slider_content_home {\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n\n    .slick_slider_custom_arrows, .home_page_main_slider_mt .slick-dots {\n        top: 65%;\n        padding-left: 50px;\n    }\n\n    .slick_left_arrow {\n        left: 3%;\n    }\n\n    .slick_right_arrow {\n        left: 28%;\n    }\n\n    .main_container {\n        padding: 0 30px !important;\n    }\n\n    span.icons_with_text_button_text {\n        display: none;\n    }\n}\n\n@media (max-width: 1025px) {\n    .react_player_mt {\n        height: 300px !important;\n    }\n\n    .footer_menu_content_contain {\n        padding-right: 40px;\n    }\n\n    .icons_with_text_heading_home_mt, .text_main_home_mt {\n        width: 100% !important;\n    }\n}\n\n.video_block_bg_img img {\n    cursor: pointer;\n}\n\n@media (max-width: 1025px) {\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {\n        right: 10%;\n    }\n\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {\n        left: 10%;\n    }\n}\n\n@media (max-width: 950px) {\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {\n        right: 5%;\n    }\n\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {\n        left: 5%;\n    }\n\n    img.logo_width_set {\n        width: 80%;\n    }\n\n    .header_center_mt {\n        align-items: center;\n    }\n\n    .footer_menu_content_contain {\n        padding-right: 20px !important;\n    }\n\n    .footer_divider {\n        margin-right: 30px !important;\n        margin-left: 20px !important;\n    }\n\n    .policies-content {\n        width: 100%;\n        padding: 0px 20px;\n    }\n}\n\n/* tabview  */\n@media (max-width: 769px) {\n    .searchBox_searchPage {\n        margin: 0 !important;\n        padding: 0px 20px 15px;\n    }\n\n    .hamburger_menu_icon {\n        background: transparent !important;\n        color: #000;\n        outline: none !important;\n    }\n\n    .hamburger_menu_icon svg {\n        width: 25px;\n        height: 25px;\n        color: #000;\n        font-weight: 600;\n    }\n\n    .hamburger_menu_icon:focus, .hamburger_menu_icon[data-focus] {\n        box-shadow: none !important;\n    }\n\n    .drill_cut_tv_popup {\n        max-width: 95% !important;\n    }\n\n    .drillcuttv_popup_close_btn {\n        right: -5px !important;\n        top: -25px !important;\n    }\n\n    .gallerySliderCloseButton {\n        top: -6% !important;\n        right: 0;\n        border-radius: 50% !important;\n        background: #FFF !important;\n        z-index: 9;\n        box-shadow: 0px 0px 10px rgb(0 0 0 / 25%);\n    }\n\n    .clearallfilters_mt_btn {\n        margin-top: 20px !important;\n    }\n\n    .filter_select_box {\n        margin-top: 20px;\n    }\n\n    .background_image_mt_content_main {\n        padding-left: 30px;\n    }\n\n    .main_container {\n        padding: 0 15px;\n    }\n\n    .slider_components_mt {\n        flex-direction: column;\n    }\n\n    .drllcutfilterLink {\n        font-size: 11px !important;\n        padding-top: 10px;\n        padding-bottom: 5px;\n    }\n\n    .drllcutfilterLink span {\n        display: block;\n        margin-top: -10px;\n    }\n\n    .drillcutsearchMainResult {\n        padding: 25px 20px !important;\n    }\n\n    .drillcutreusultcount {\n        font-size: 24px !important;\n        padding: 20px 15px !important;\n    }\n\n    .searchDrillcutfilters {\n        padding: 0 0 10px 0 !important;\n    }\n\n    .main_slider_home_content_mt {\n        padding: 25px !important;\n        margin-bottom: 87px;\n    }\n\n    .main_slider_home_content_main {\n        order: 1;\n    }\n\n    .half_mini_width_drillcut {\n        width: 100%;\n    }\n\n    .box_view_design_mt, .latest_product_contain, .blog_section_drillcut {\n        flex-direction: column;\n    }\n\n    .box_design {\n        margin: 15px 0 0;\n        background-size: 100%;\n        height: 180px;\n        background-repeat: no-repeat;\n    }\n\n    .box_homepage_designs_content {\n        bottom: 8%;\n    }\n\n    .box_homepage_designs_heading {\n        font-size: 24px !important;\n        line-height: 5px !important;\n    }\n\n    .backgorund_latest_prod_mt {\n        height: 250px;\n    }\n\n    .icons_with_text_heading_home_mt_logo svg {\n        width: 25px;\n        height: 25px;\n    }\n\n    .half_width_class_mt {\n        width: 100%;\n    }\n\n    .slider_component_box {\n        order: 1;\n        height: 350px;\n    }\n\n    .slider_content_home {\n        padding: 20px !important;\n        height: 100%;\n    }\n\n    .home_page_main_slider_mt .slick-dots {\n        width: 100%;\n        bottom: 35px !important;\n        top: unset !important;\n        padding-left: 50px;\n    }\n\n    .slick_slider_custom_arrows {\n        bottom: 35px !important;\n        top: unset !important;\n    }\n\n    .main_container_mt {\n        padding: 0 15px !important;\n    }\n\n    .slick_left_arrow {\n        left: 5%;\n    }\n\n    .latest_product_div_mt {\n        margin: 15px 0;\n        flex-direction: column;\n        height: 100%;\n    }\n\n    .blog_design_mt {\n        margin: 15px 0;\n    }\n\n    .slick_right_arrow {\n        left: 36%;\n    }\n\n    /*.slider_image_mt {*/\n    /*    height: 200px;*/\n    /*}*/\n    .icons_with_text_heading_home_mt {\n        width: 100% !important;\n        padding: 0 15px;\n    }\n\n    .text_main_home_mt {\n        padding: 0 15px;\n    }\n\n    .Background_color_schema_div {\n        padding: 50px 0 50px;\n    }\n\n    .logo_text_block_contain {\n        justify-content: flex-start;\n    }\n\n    .slick_arrows_custom_blog {\n        position: absolute;\n        top: 3px;\n    }\n\n    .background_image_mt_content_main_text {\n        max-width: 270px;\n    }\n\n    .slick_arrows_custom_blog svg {\n        width: 20px;\n        height: 20px;\n        fill: #592C82;\n    }\n\n    .slick_arrows_custom_blog_previous {\n        left: 25%;\n    }\n\n    .slick_arrows_custom_blog_next {\n        right: 27%;\n    }\n\n    .custom_dots_blog {\n        position: relative;\n    }\n\n    .blog_section_home_button {\n        margin-top: 60px;\n    }\n\n    .background_image_mt_content {\n        left: 0;\n        padding: 15px;\n    }\n\n    .blog_section_home_button_div {\n        margin-bottom: 0;\n    }\n\n    .drill_cut_tv_Homemt {\n        padding-bottom: 40px !important;\n    }\n\n    .slick_arrows_custom_logo {\n        width: 30px;\n        height: 30px;\n    }\n\n    .text_logo_section_logo_mt {\n        grid-gap: 30px 5px;\n    }\n\n    .logo_icons_logo_mt {\n        height: auto;\n    }\n\n    .Logo_icons_full_width {\n        padding: 0;\n    }\n\n    .text_logo_section_logo_mt {\n        grid-gap: 25px 0 !important;\n    }\n\n    .blog_section_mobile_slider .slick-dots li button::before, .slider_instafeed .slick-dots li button::before {\n        color: #F2F2F2 !important;\n    }\n\n    .blog_section_mobile_slider .slick-dots li.slick-active button:before, .slider_instafeed .slick-dots li.slick-active button:before {\n        color: #EC7700 !important;\n    }\n\n    .logo_icons_logo_mt img {\n        max-width: 80%;\n    }\n\n    .logo_icons_logo_mt {\n        margin: 40px 0 15px;\n    }\n\n    .background_image_mt_container {\n        left: 0;\n        padding: 25px;\n    }\n\n    .latest_product_heading {\n        margin-bottom: 25px;\n    }\n\n    .instagram_slider {\n        margin-top: 30px;\n    }\n\n    .slider_instafeed .slick_arrows_custom_blog_previous {\n        left: 20%;\n    }\n\n    .slider_instafeed .slick_arrows_custom_blog_next {\n        right: 20%;\n    }\n\n    .slider_instafeed .slick-dots {\n        bottom: -40px;\n    }\n\n    .slider_instafeed .slick_arrows_custom_blog {\n        top: 18px;\n    }\n\n    /* ========================================== About Us page Drillcut mobile_view ============================================ */\n    .about_announcment_container {\n        padding: 23px 0;\n    }\n\n    .pages_announment_bar_heading {\n        font-size: 24px !important;\n        line-height: 24px;\n        text-align: left;\n        padding: 0 20px;\n        line-height: 30px !important;\n    }\n\n    .pages_announment_bar_sub_heading {\n        padding: 0 20px;\n    }\n\n    .about_container {\n        padding: 0 20px !important;\n    }\n\n    .about_us_content_mt {\n        max-width: 100%;\n        margin: 20px 0;\n        letter-spacing: 0.5px;\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .video_about_mt {\n        margin-bottom: 45px;\n    }\n\n    .about_us_brands_heading {\n        margin-bottom: 40px !important;\n    }\n\n    .about_2_box {\n        padding: 0 !important;\n    }\n\n    .brand_logo_aboutuspage {\n        margin-bottom: 30px;\n    }\n\n    .heading_image_withtext_about {\n        margin-top: 30px;\n    }\n\n    .button_mt_about {\n        width: 203px;\n    }\n\n    .aboutus_imagewithtext_Box {\n        margin-bottom: 30px;\n    }\n\n    .about_slider_bg_image_mt {\n        margin-top: 40px;\n        min-height: 451px;\n    }\n\n    .about_us_page_slider {\n        max-width: 100% !important;\n    }\n\n    .about_us_page_sliderContent {\n        font-size: 24px;\n        line-height: 24px;\n    }\n\n    .about_page_slider_container_mt_heading {\n        font-size: 24px !important;\n    }\n\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_next {\n        right: -2%;\n    }\n\n    .about_page_slider_container_contentmt .slick_arrows_custom_logo_previous {\n        left: -2%;\n    }\n\n    .aboutpage_sliderBox {\n        max-width: 260px;\n    }\n\n    .logo_image_button_aboutuspage {\n        width: 140px !important;\n        height: 140px !important;\n    }\n\n    .substainibilitypage_container {\n        margin: 25px 0 25px;\n    }\n\n    .main_slider_home_heading_mt {\n        font-size: 18px !important;\n        line-height: 22px !important;\n        max-width: 90%;\n    }\n\n    .about_page_popupBody img {\n        width: 180px !important;\n        height: 180px !important;\n    }\n\n    .contactUspage_block {\n        flex-direction: column;\n        margin-top: 25px\n    }\n\n    .width_40DrillCut, .width_60DrillCut, .width_25DrillCut, .width_75DrillCut, .box_width_70, .box_width_30 {\n        width: 100%;\n    }\n\n    .downloads_pageContainer {\n        flex-direction: column;\n    }\n\n    .contactUspage_block_Details {\n        margin-top: 0;\n        padding: 0px 20px;\n    }\n\n    .container_padding_remove {\n        padding: 0 !important;\n    }\n\n    .contactUspage_block_Form_block {\n        padding: 40px 20px;\n    }\n\n    .bottom_border_contactUspage {\n        margin: 0 20px;\n    }\n\n    .drillcuttv_page_header_buttons {\n        padding: 20px;\n    }\n\n    .drillcuttv_subfilters_button_mt {\n        font-size: 14px !important;\n        text-transform: uppercase;\n        font-weight: 600 !important;\n        padding: 15px !important;\n        justify-content: space-between;\n    }\n\n    .css-1ygl3x:focus, .css-1ygl3x[data-focus] {\n        box-shadow: none !important;\n    }\n\n    .accordin_content_mobileview {\n        padding: 0 !important;\n    }\n\n    .accordin_content_mobileview_heading {\n        letter-spacing: 0.15px;\n        font-size: 20px !important;\n        line-height: 24px !important;\n        padding: 15px 0;\n        text-align: left;\n    }\n\n    .filter_select_box {\n        background: #FFFFFF;\n        border-radius: 4px;\n        padding: 15px;\n        position: relative;\n    }\n\n    .filter_select_box_heading {\n        color: rgba(0, 0, 0, 0.5);\n        letter-spacing: 0.1px;\n        text-transform: uppercase;\n        font-size: 10px !important;\n        line-height: 12px !important;\n        font-weight: 700 !important;\n        text-align: left;\n    }\n\n    select#tag_onchange_mobile {\n        border: none;\n        padding: 0 !important;\n        letter-spacing: 0.15px;\n        font-weight: 700;\n        font-size: 16px !important;\n        line-height: 24px !important;\n        height: auto !important;\n        width: 100%;\n    }\n\n    .css-k7r2wc:focus, .css-k7r2wc[data-focus] {\n        box-shadow: none !important;\n    }\n\n    .clearallfilters_mt_btn {\n        width: 100% !important;\n        background: #4D4D4D !important;\n        border-radius: 5px !important;\n        color: #FFF;\n        font-weight: 700 !important;\n        font-size: 12px !important;\n        line-height: 12px !important;\n        margin-bottom: 20px;\n    }\n\n    .clearallfilters_mt_btn:hover {\n        background: #4D4D4D !important;\n    }\n\n    .filter_select_box_checkbox {\n        padding: 0 !important;\n        justify-content: space-between;\n    }\n\n    .filter_select_box_checkbox_heading {\n        letter-spacing: 0.15px;\n        font-size: 16px !important;\n        line-height: 24px !important;\n        justify-content: space-between;\n    }\n\n    .drillcuttv_subfilters_checkbox {\n        margin: 15px 0;\n    }\n\n    .filter_select_box_checkbox:hover, .filter_select_box_checkbox[data-hover] {\n        background: transparent !important;\n    }\n\n    .slider_gallery_images {\n        width: 100% !important;\n    }\n\n    .sliderImages {\n        margin: 0 !important;\n    }\n\n    .slider_gallery_images {\n        height: auto !important;\n    }\n\n    .mobileviewimagewithtextArticle {\n        padding: 50px 20px 10px !important;\n    }\n\n    .newsletter_block_articleDrillcut {\n        width: 100% !important;\n    }\n\n    .newletterContent {\n        width: 100%;\n    }\n\n    .social_iconsArticleContent {\n        flex-direction: column;\n    }\n\n    .article_social_icons {\n        margin-top: 40px;\n    }\n\n    .article_last_border {\n        margin-bottom: 40px;\n    }\n\n    .back_button {\n        width: 130px !important;\n    }\n\n    .downloads_page_content_mt {\n        flex-direction: column;\n    }\n\n    .tableblogdownloadspage_mt tr {\n        padding: 0 !important;\n    }\n\n    .downloads_page_space {\n        padding: 0 20px !important;\n    }\n\n    .downloads_pagepagination {\n        padding: 20px 0 !important;\n    }\n\n    .downloads_page_content_mt {\n        padding: 30px 0 !important;\n        align-items: unset !important;\n    }\n\n    .download_button_mt {\n        align-items: center;\n        justify-content: center;\n        margin-top: 20px;\n    }\n\n    #tag_onchange_mobile {\n        cursor: pointer;\n    }\n\n    .back_button {\n        margin-bottom: 20px;\n    }\n\n    /*  Search page mobile view */\n    .searchmobileviewmt {\n        flex-direction: column;\n    }\n\n    .drllcutfilterLink {\n        flex-direction: column;\n    }\n\n    .searchDrillcutfilters {\n        overflow: hidden;\n    }\n\n    .searchDatamt ul {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    #tag_onchange_mobile:focus-visible {\n        outline: none !important;\n    }\n\n    #tag_onchange_mobile:focus {\n        background: transparent !important;\n    }\n\n    div#one[aria-expanded=\"true\"] .arrowactivetabsearch {\n        left: 12.5%;\n    }\n\n    div#two[aria-expanded=\"true\"] .arrowactivetabsearch {\n        left: 36.5%;\n    }\n\n    div#four[aria-expanded=\"true\"] .arrowactivetabsearch {\n        left: 82.5%;\n    }\n\n    .searchBox_searchPage input.ais-SearchBox-input {\n        width: 100%;\n    }\n\n    .SearchNormalBox {\n        width: 100% !important;\n    }\n\n    .CollectionsData {\n        flex-direction: column;\n    }\n\n    .selectbox_Box {\n        width: 100%;\n    }\n\n    .collection_grid {\n        padding: 20px;\n    }\n\n\n    .pagination_top {\n        display: none;\n    }\n\n    .searchPage_pagination_bottom {\n        padding: 0px 20px 20px 20px;\n        flex-wrap: wrap;\n        flex-direction: column-reverse;\n    }\n\n    .paginate_count {\n        width: 100%;\n    }\n\n    .Sort_pagination {\n        justify-content: center;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .searchPage_pagination .ais-Pagination {\n        margin-left: 0px;\n    }\n\n    .searchPage_pagination .ais-Pagination-item--previousPage, .searchPage_pagination .ais-Pagination-item--nextPage {\n        background: #ec7700 !important;\n    }\n\n    .searchPage_pagination .ais-Pagination-item--disabled {\n        background: #ec770080 !important;\n    }\n}\n\n@media (max-width: 390px) {\n    .slider_component_box {\n        height: 320px;\n    }\n\n    .home_page_main_slider_mt .slick-dots {\n        bottom: 7% !important;\n    }\n\n    .slick_slider_custom_arrow {\n        margin-top: 4px;\n    }\n}\n\n\n/* rs css start */\n.container_padding_remove_rs {\n    padding: 0px !important;;\n}\n\n.text_bg_login {\n    /* background: url(../images/login_page.jpg); */\n    background: url(./image/purple_banner_cranes.webp) no-repeat;\n    position: relative;\n    background-position: bottom;\n    background-size: cover;\n    height: 830px;\n    padding-top: 100px !important;\n\n}\n\n.form-login h2 {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 24px;\n    /* identical to box height, or 100% */\n\n\n    text-align: center;\n    letter-spacing: 0.18px;\n\n    color: #000000;\n    padding-top: 70px;\n    /*padding-bottom: 40px;*/\n}\n\n.form-mail-lg {\n    margin-bottom: 21px;\n}\n\n.form-login p {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    /* or 133% */\n\n\n    letter-spacing: 0.4px;\n\n    color: #000000;\n    padding-top: 10px;\n    text-align: left;\n}\n\n.form-login input {\n    background: #FFFFFF;\n    border: 1px solid #C4C4C4;\n    border-radius: 5px;\n    max-width: 310px;\n    border: 1px solid #C4C4C4;\n}\n\n.form-login input:focus,\n.form-login input[data-focus] {\n\n\n    border-color: transparent !important;\n    box-shadow: 0 0 0 1px transparent !important;\n}\n\n.form_login_Button {\n    font-style: normal;\n    font-weight: 700 !important;\n    font-size: 15px !important;\n    line-height: 56px !important;\n    margin-right:0px !important;\n    /* or 373% */\n\n\n    align-items: center;\n    text-align: center;\n    transition: all 0.3s ease-in;\n    color: #FFFFFF;\n    height: 64px;\n    width: 100%;\n    margin: 22px 0px 17px;\n    cursor: pointer;\n}\n\n.form_login_Button:hover {\n    background-color: #000;\n    color: #EC7700;\n    transition: all 0.3s ease-in;\n}\n\n.text_bg_login:before {\n    position: absolute;\n    content: '';\n    height: 100%;\n    width: 100%;\n    /* background-blend-mode: multiply; */\n    /*background-color: rgb(89 44 130 / 85%);*/\n    display: block;\n    background-blend-mode: multiply;\n    transform: matrix(-1, 0, 0, 1, 0, 0);\n    top: 0px;\n}\n\n\n.form-login {\n    position: relative;\n    background: #F2F2F2;\n    max-width: 500px;\n    width: 100%;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n    margin: 0px auto;\n    display: block;\n    padding: 0px 95px;\n}\n\n.form-login label {\n    /* font-family: 'Acumin Pro'; */\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    /* identical to box height, or 133% */\n\n\n    letter-spacing: 0.15px;\n    text-transform: uppercase;\n\n    color: #000000;\n}\n\n.ct_acc {\n    font-weight: 700;\n    font-size: 15px;\n\n    align-items: center;\n    text-align: center;\n    color: #EC7700;\n    transition: all 0.3s ease-in;\n}\n\n.ct_acc:hover {\n    color: #000;\n    transition: all 0.3s ease-in;\n}\n\n.ct_ft_pw {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    align-items: center;\n    text-align: center;\n    text-decoration-line: underline;\n    color: #EC7700;\n    margin-top: 22px;\n    display: block;\n    transition: all 0.3s ease-in;\n\n}\n\n.ct_ft_pw:hover {\n    color: #000;\n    transition: all 0.3s ease-in;\n}\n\n\n.form_dt_ft {\n    padding-bottom: 65px;\n}\n\n/* signup page css start */\n.signuppage_block {\n    padding: 75px 0px;\n}\n\n.login_block_Details {\n    text-align: left;\n}\n\n.login_block_Details p {\n    font-style: normal;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 24px;\n    /* or 150% */\n\n    letter-spacing: 0.5px;\n\n    color: #000000;\n    padding-bottom: 15px;\n}\n\n.signup_heading {\n    font-style: normal;\n    font-weight: 700 !important;\n    font-size: 20px !important;\n    line-height: 24px !important;\n    letter-spacing: 0.15px;\n    padding-bottom: 17px;\n\n}\n\n.list_dt {\n\n    list-style-type: none !important;\n    padding: 0px;\n    margin: 0px;\n    margin-inline-start: 0em !important;\n}\n\n.list_dt li {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 30px;\n    letter-spacing: 0.1px;\n\n    color: #000000;\n}\n\n.list_dt .chakra-icon {\n    margin-right: 7px;\n}\n\n.fllo_signpage {\n\n    font-style: normal;\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    letter-spacing: 0.5px;\n    color: #000000;\n    padding-top: 60px;\n}\n\n.folow_icon_block svg {\n    color: #000000;\n    font-size: 19px;\n}\n\n.login_page_block h3 {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 24px;\n    /* display: flex; */\n    /* align-items: center; */\n    text-align: center;\n    letter-spacing: 0.18px;\n    color: #000000;\n    padding: 35px 0px 22px;\n}\n\n.login_page_block {\n    padding: 0px 28px;\n}\n\n.login_page_block label {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    /* identical to box height, or 133% */\n\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.15px;\n    text-transform: uppercase;\n\n    color: #000000;\n\n}\n\n.login_page_block input {\n    background: #FFFFFF;\n    border: 1px solid #C4C4C4;\n    border-radius: 5px;\n}\n\n.exits_custm {\n    font-style: normal;\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 24px;\n\n\n    letter-spacing: 0.25px;\n    color: #000000;\n    text-align: left;\n    padding-left: 9px;\n    padding: 20px 0px 10px 9px;\n}\n\n.sign_info {\n    font-style: normal;\n    font-weight: 700 !important;\n    font-size: 24px !important;\n    line-height: 24px !important;\n    text-align: center;\n    letter-spacing: 0.18px;\n    color: #000000;\n    padding: 50px 0px 36px;\n}\n\n.pw_az {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 19px;\n    letter-spacing: 0.4px;\n    color: #000000;\n    text-align: left;\n    padding: 20px 0px 45px 9px;\n}\n\n.signup_submit_Button {\n    height: 45px !important;;\n    padding: 4px 45px !important;\n    transition: all 0.3s ease-in;\n    /*margin-bottom: 71px;*/\n}\n\n.signup_submit_Button:hover {\n    background-color: #000;\n    color: #EC7700;\n    transition: all 0.3s ease-in;\n}\n\n\n/* rs media query  */\n@media (max-width: 991px) {\n    .text_bg_login {\n        background: none;\n        background-color: #F2F2F2;\n    }\n\n    .text_bg_login:before {\n        background-color: #F2F2F2;\n    }\n\n    .form-login {\n        box-shadow: none;\n    }\n\n    .form-login {\n        padding: 0px 32px;\n    }\n\n    .form-login input {\n        max-width: 100%;\n    }\n\n    .form-login h2 {\n        padding-top: 0px;\n    }\n\n    .text_bg_login {\n\n        height: 608px;\n        padding-top: 80px !important;\n        border-bottom: 2px solid #E6E6E6;\n    }\n}\n\n@media (max-width: 768px) {\n    .signuppage_block {\n        flex-direction: column;\n        padding: 35px 0px;\n\n    }\n\n    .login_block_Details {\n        padding: 0px 42px;\n    }\n\n    .login_block_Details p {\n        padding-bottom: 30px;\n    }\n\n    .signup_heading {\n        padding-bottom: 9px;\n    }\n\n    .fllo_signpage {\n\n        padding-top: 20px;\n    }\n\n    .form_lg_pdt {\n        padding-top: 20px;\n    }\n\n    .exits_custm {\n        padding: 10px 0px 10px 9px;\n    }\n\n    .sign_info {\n        padding: 20px 0px 26px;\n    }\n\n    .pd_btmuser {\n        padding-bottom: 0px;\n    }\n}\n\n.error-show {\n    color: red;\n    text-align: initial;\n    font-size: 10px;\n    text-transform: uppercase;\n    margin-left: 15px;\n}\n\n.checkbox-circle {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border: 1px solid #a4a4a4;\n}\n\n.checkbox-circle:checked {\n    background-color: #0075ff;\n    box-shadow: inset 0 0 0 3px #FFFFFF;\n    border-color: #0075ff;\n}\n\n/* product page sign in modal */\n.product_sign_in .text_bg_login {\n    height: auto !important;\n    padding: 0 !important;\n    background-color: #fff !important;\n}\n\n#chakra-modal-product_sign_in_popup {\n    background-color: #f2f2f2 !important;\n}\n\n#chakra-modal-product_sign_in_popup .form_dt_ft {\n    text-align: center;\n}\n\n#chakra-modal-product_sign_in_popup .form-login {\n    box-shadow: unset !important;\n}\n\n.grid-product-downloads {\n    grid-template-columns: auto auto auto;\n}\n\n.viewmore-btn {\n    background: #EC7700 !important;\n    color: #FFF !important;\n}\n\n@media (min-width: 991px) and  (max-width: 1200px) {\n    .grid-product-downloads {\n        grid-template-columns: auto auto;\n    }\n}\n\n.main_container.header_center_mt.css-1olzamh >.css-0{\n    max-width: 240px;\n    width:100%;\n  }\n  .footer_logo_main.css-8j73os >.css-0{\n    max-width: 240px;\n    width: 100%;\n  }\n\n\n  .aa-Panel {\n      display: none;\n  }\n\n    .custom-aa-Panel.aa-Panel {\n        display: block;\n    }\n\n    .aa-InputWrapper {\n        padding-left: 10px;\n    }\n\n.aa-Input::placeholder {\n    color: #454141;\n}\n\n.aa-Label {\n    background-color: #553C9A;\n}\n\n.aa-SubmitIcon {\n  color: white !important;\n}\n\n.aa-Form {\n    border-radius: 12px 12px 12px 12px !important;\n}\n\n.aa-Label {\n    border-radius: 0px 10px 10px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
